
export const sampleProfileData = {
    onefootball: {
        usernameData: {
            "data": {
                "user": {
                    "result": {
                        "__typename": "User",
                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                        "rest_id": "799369969725227008",
                        "affiliates_highlighted_label": {},
                        "is_blue_verified": true,
                        "profile_image_shape": "Circle",
                        "legacy": {
                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                            "default_profile": false,
                            "default_profile_image": false,
                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                            "entities": {
                                "description": {
                                    "urls": []
                                },
                                "url": {
                                    "urls": [
                                        {
                                            "display_url": "onefootball.link/46igysv",
                                            "expanded_url": "https://onefootball.link/46igysv",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "indices": [
                                                0,
                                                23
                                            ]
                                        }
                                    ]
                                }
                            },
                            "fast_followers_count": 0,
                            "favourites_count": 623,
                            "followers_count": 176949,
                            "friends_count": 576,
                            "has_custom_timelines": true,
                            "is_translator": false,
                            "listed_count": 709,
                            "location": "Download the app 👉",
                            "media_count": 15515,
                            "name": "OneFootball",
                            "normal_followers_count": 176949,
                            "pinned_tweet_ids_str": [],
                            "possibly_sensitive": false,
                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1724502872",
                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                            "profile_interstitial_type": "",
                            "screen_name": "OneFootball",
                            "statuses_count": 20685,
                            "translator_type": "none",
                            "url": "https://t.co/RIUfSIx7Ud",
                            "verified": false,
                            "withheld_in_countries": []
                        },
                        "professional": {
                            "rest_id": "1772986690761568583",
                            "professional_type": "Business",
                            "category": [
                                {
                                    "id": 1009,
                                    "name": "Community",
                                    "icon_name": "IconBriefcaseStroke"
                                }
                            ]
                        },
                        "legacy_extended_profile": {},
                        "is_profile_translatable": false,
                        "has_hidden_likes_on_profile": true,
                        "has_hidden_subscriptions_on_profile": false,
                        "verification_info": {
                            "is_identity_verified": false,
                            "reason": {
                                "description": {
                                    "text": "This account is verified. Learn more",
                                    "entities": [
                                        {
                                            "from_index": 26,
                                            "to_index": 36,
                                            "ref": {
                                                "url": "https://help.twitter.com/managing-your-account/about-twitter-verified-accounts",
                                                "url_type": "ExternalUrl"
                                            }
                                        }
                                    ]
                                },
                                "verified_since_msec": "1499434924084"
                            }
                        },
                        "highlights_info": {
                            "can_highlight_tweets": true,
                            "highlighted_tweets": "6"
                        },
                        "user_seed_tweet_count": 0,
                        "business_account": {},
                        "creator_subscriptions_count": 0
                    }
                }
            }
        },
        userTweetsData: [
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1812211645571055877",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1812211645571055877"
                                ],
                                "editable_until_msecs": "1720903500000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "5438",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                            "legacy": {
                                "bookmark_count": 1,
                                "bookmarked": false,
                                "created_at": "Sat Jul 13 19:45:00 +0000 2024",
                                "conversation_id_str": "1812211645571055877",
                                "display_text_range": [
                                    0,
                                    60
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/ebmktnzweq",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1812211645571055877/photo/1",
                                            "id_str": "1812086002602692608",
                                            "indices": [
                                                61,
                                                84
                                            ],
                                            "media_key": "3_1812086002602692608",
                                            "media_url_https": "https://pbs.twimg.com/media/GSXSnleXUAA0ygU.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/EBmKTnzwEQ",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 690,
                                                            "y": 353,
                                                            "h": 90,
                                                            "w": 90
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 613,
                                                            "y": 313,
                                                            "h": 80,
                                                            "w": 80
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 347,
                                                            "y": 177,
                                                            "h": 45,
                                                            "w": 45
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 690,
                                                            "y": 353,
                                                            "h": 90,
                                                            "w": 90
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 204,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 405,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1812086002602692608"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.x.com/ebmktnzweq",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1812211645571055877/photo/1",
                                            "id_str": "1812086002548170752",
                                            "indices": [
                                                61,
                                                84
                                            ],
                                            "media_key": "3_1812086002548170752",
                                            "media_url_https": "https://pbs.twimg.com/media/GSXSnlRXYAAQg6E.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/EBmKTnzwEQ",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 276,
                                                            "y": 146,
                                                            "h": 105,
                                                            "w": 105
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 245,
                                                            "y": 129,
                                                            "h": 93,
                                                            "w": 93
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 139,
                                                            "y": 73,
                                                            "h": 52,
                                                            "w": 52
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 276,
                                                            "y": 146,
                                                            "h": 105,
                                                            "w": 105
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 1,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 304,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1812086002548170752"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.x.com/ebmktnzweq",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1812211645571055877/photo/1",
                                            "id_str": "1812086002585878532",
                                            "indices": [
                                                61,
                                                84
                                            ],
                                            "media_key": "3_1812086002585878532",
                                            "media_url_https": "https://pbs.twimg.com/media/GSXSnlaWwAQJ2en.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/EBmKTnzwEQ",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 136,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 371,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1812086002585878532"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.x.com/ebmktnzweq",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1812211645571055877/photo/1",
                                            "id_str": "1812086002573266944",
                                            "indices": [
                                                61,
                                                84
                                            ],
                                            "media_key": "3_1812086002573266944",
                                            "media_url_https": "https://pbs.twimg.com/media/GSXSnlXWUAAOoFs.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/EBmKTnzwEQ",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 136,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 405,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1812086002573266944"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/EBmKTnzwEQ",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1812211645571055877/photo/1",
                                            "id_str": "1812086002602692608",
                                            "indices": [
                                                61,
                                                84
                                            ],
                                            "media_key": "3_1812086002602692608",
                                            "media_url_https": "https://pbs.twimg.com/media/GSXSnleXUAA0ygU.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/EBmKTnzwEQ",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 690,
                                                            "y": 353,
                                                            "h": 90,
                                                            "w": 90
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 613,
                                                            "y": 313,
                                                            "h": 80,
                                                            "w": 80
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 347,
                                                            "y": 177,
                                                            "h": 45,
                                                            "w": 45
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 690,
                                                            "y": 353,
                                                            "h": 90,
                                                            "w": 90
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 204,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 405,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1812086002602692608"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.twitter.com/EBmKTnzwEQ",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1812211645571055877/photo/1",
                                            "id_str": "1812086002548170752",
                                            "indices": [
                                                61,
                                                84
                                            ],
                                            "media_key": "3_1812086002548170752",
                                            "media_url_https": "https://pbs.twimg.com/media/GSXSnlRXYAAQg6E.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/EBmKTnzwEQ",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 276,
                                                            "y": 146,
                                                            "h": 105,
                                                            "w": 105
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 245,
                                                            "y": 129,
                                                            "h": 93,
                                                            "w": 93
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 139,
                                                            "y": 73,
                                                            "h": 52,
                                                            "w": 52
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 276,
                                                            "y": 146,
                                                            "h": 105,
                                                            "w": 105
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 1,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 304,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1812086002548170752"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.twitter.com/EBmKTnzwEQ",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1812211645571055877/photo/1",
                                            "id_str": "1812086002585878532",
                                            "indices": [
                                                61,
                                                84
                                            ],
                                            "media_key": "3_1812086002585878532",
                                            "media_url_https": "https://pbs.twimg.com/media/GSXSnlaWwAQJ2en.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/EBmKTnzwEQ",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 136,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 371,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1812086002585878532"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.twitter.com/EBmKTnzwEQ",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1812211645571055877/photo/1",
                                            "id_str": "1812086002573266944",
                                            "indices": [
                                                61,
                                                84
                                            ],
                                            "media_key": "3_1812086002573266944",
                                            "media_url_https": "https://pbs.twimg.com/media/GSXSnlXWUAAOoFs.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/EBmKTnzwEQ",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 136,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 405,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1812086002573266944"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 112,
                                "favorited": false,
                                "full_text": "Safe to say the sprinkler surprised England's Ezri Konsa 🤣 💦 https://t.co/EBmKTnzwEQ",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 0,
                                "reply_count": 2,
                                "retweet_count": 6,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1812211645571055877"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1792570979287466331",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1792570979287466331"
                                ],
                                "editable_until_msecs": "1716220800000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "9349",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://twitter.com\" rel=\"nofollow\">TweetDeck Web App</a>",
                            "legacy": {
                                "bookmark_count": 5,
                                "bookmarked": false,
                                "created_at": "Mon May 20 15:00:00 +0000 2024",
                                "conversation_id_str": "1792570979287466331",
                                "display_text_range": [
                                    0,
                                    254
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/wuyamxaul8",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1792570979287466331/photo/1",
                                            "id_str": "1792542441070829569",
                                            "indices": [
                                                255,
                                                278
                                            ],
                                            "media_key": "3_1792542441070829569",
                                            "media_url_https": "https://pbs.twimg.com/media/GOBj2lTWoAEjJws.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/WUYAMXauL8",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 162,
                                                            "y": 775,
                                                            "h": 216,
                                                            "w": 216
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 144,
                                                            "y": 688,
                                                            "h": 192,
                                                            "w": 192
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 81,
                                                            "y": 390,
                                                            "h": 108,
                                                            "w": 108
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 162,
                                                            "y": 775,
                                                            "h": 216,
                                                            "w": 216
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 405,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1792542441070829569"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/WUYAMXauL8",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1792570979287466331/photo/1",
                                            "id_str": "1792542441070829569",
                                            "indices": [
                                                255,
                                                278
                                            ],
                                            "media_key": "3_1792542441070829569",
                                            "media_url_https": "https://pbs.twimg.com/media/GOBj2lTWoAEjJws.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/WUYAMXauL8",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 162,
                                                            "y": 775,
                                                            "h": 216,
                                                            "w": 216
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 144,
                                                            "y": 688,
                                                            "h": 192,
                                                            "w": 192
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 81,
                                                            "y": 390,
                                                            "h": 108,
                                                            "w": 108
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 162,
                                                            "y": 775,
                                                            "h": 216,
                                                            "w": 216
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 405,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1792542441070829569"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 494,
                                "favorited": false,
                                "full_text": "Aston Villa appear to have confirmed they will switch club crests AGAIN, just one season after switching to the new circular design 😳🔁\n\nThe new logo, which was leaked back in January, features in Aston Villa's recently-announced partnership with adidas 👀 https://t.co/WUYAMXauL8",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 1,
                                "reply_count": 3,
                                "retweet_count": 35,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1792570979287466331"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1788638807320875162",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1788638807320875162"
                                ],
                                "editable_until_msecs": "1715283297000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "12106",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                            "legacy": {
                                "bookmark_count": 7,
                                "bookmarked": false,
                                "created_at": "Thu May 09 18:34:57 +0000 2024",
                                "conversation_id_str": "1788638807320875162",
                                "display_text_range": [
                                    0,
                                    103
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/4mwd1ttjrh",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1788638807320875162/photo/1",
                                            "id_str": "1788638758486577152",
                                            "indices": [
                                                104,
                                                127
                                            ],
                                            "media_key": "3_1788638758486577152",
                                            "media_url_https": "https://pbs.twimg.com/media/GNKFeWcWkAAjdHr.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/4mwD1ttJrh",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 512,
                                                            "y": 34,
                                                            "h": 63,
                                                            "w": 63
                                                        },
                                                        {
                                                            "x": 367,
                                                            "y": 729,
                                                            "h": 439,
                                                            "w": 439
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 455,
                                                            "y": 30,
                                                            "h": 56,
                                                            "w": 56
                                                        },
                                                        {
                                                            "x": 326,
                                                            "y": 648,
                                                            "h": 390,
                                                            "w": 390
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 257,
                                                            "y": 17,
                                                            "h": 31,
                                                            "w": 31
                                                        },
                                                        {
                                                            "x": 184,
                                                            "y": 367,
                                                            "h": 221,
                                                            "w": 221
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 512,
                                                            "y": 34,
                                                            "h": 63,
                                                            "w": 63
                                                        },
                                                        {
                                                            "x": 367,
                                                            "y": 729,
                                                            "h": 439,
                                                            "w": 439
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 676,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 270,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 119,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 236,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1788638758486577152"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.x.com/4mwd1ttjrh",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1788638807320875162/photo/1",
                                            "id_str": "1788638758474059778",
                                            "indices": [
                                                104,
                                                127
                                            ],
                                            "media_key": "3_1788638758474059778",
                                            "media_url_https": "https://pbs.twimg.com/media/GNKFeWZXkAI9p5I.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/4mwD1ttJrh",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 475,
                                                            "y": 72,
                                                            "h": 139,
                                                            "w": 139
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 422,
                                                            "y": 64,
                                                            "h": 123,
                                                            "w": 123
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 239,
                                                            "y": 36,
                                                            "h": 70,
                                                            "w": 70
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 475,
                                                            "y": 72,
                                                            "h": 139,
                                                            "w": 139
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 203,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1788638758474059778"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.x.com/4mwd1ttjrh",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1788638807320875162/photo/1",
                                            "id_str": "1788638758465646593",
                                            "indices": [
                                                104,
                                                127
                                            ],
                                            "media_key": "3_1788638758465646593",
                                            "media_url_https": "https://pbs.twimg.com/media/GNKFeWXXMAEUM3J.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/4mwD1ttJrh",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 236,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1788638758465646593"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/4mwD1ttJrh",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1788638807320875162/photo/1",
                                            "id_str": "1788638758486577152",
                                            "indices": [
                                                104,
                                                127
                                            ],
                                            "media_key": "3_1788638758486577152",
                                            "media_url_https": "https://pbs.twimg.com/media/GNKFeWcWkAAjdHr.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/4mwD1ttJrh",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 512,
                                                            "y": 34,
                                                            "h": 63,
                                                            "w": 63
                                                        },
                                                        {
                                                            "x": 367,
                                                            "y": 729,
                                                            "h": 439,
                                                            "w": 439
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 455,
                                                            "y": 30,
                                                            "h": 56,
                                                            "w": 56
                                                        },
                                                        {
                                                            "x": 326,
                                                            "y": 648,
                                                            "h": 390,
                                                            "w": 390
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 257,
                                                            "y": 17,
                                                            "h": 31,
                                                            "w": 31
                                                        },
                                                        {
                                                            "x": 184,
                                                            "y": 367,
                                                            "h": 221,
                                                            "w": 221
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 512,
                                                            "y": 34,
                                                            "h": 63,
                                                            "w": 63
                                                        },
                                                        {
                                                            "x": 367,
                                                            "y": 729,
                                                            "h": 439,
                                                            "w": 439
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 676,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 270,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 119,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 236,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1788638758486577152"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.twitter.com/4mwD1ttJrh",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1788638807320875162/photo/1",
                                            "id_str": "1788638758474059778",
                                            "indices": [
                                                104,
                                                127
                                            ],
                                            "media_key": "3_1788638758474059778",
                                            "media_url_https": "https://pbs.twimg.com/media/GNKFeWZXkAI9p5I.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/4mwD1ttJrh",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 475,
                                                            "y": 72,
                                                            "h": 139,
                                                            "w": 139
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 422,
                                                            "y": 64,
                                                            "h": 123,
                                                            "w": 123
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 239,
                                                            "y": 36,
                                                            "h": 70,
                                                            "w": 70
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 475,
                                                            "y": 72,
                                                            "h": 139,
                                                            "w": 139
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 203,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1788638758474059778"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.twitter.com/4mwD1ttJrh",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1788638807320875162/photo/1",
                                            "id_str": "1788638758465646593",
                                            "indices": [
                                                104,
                                                127
                                            ],
                                            "media_key": "3_1788638758465646593",
                                            "media_url_https": "https://pbs.twimg.com/media/GNKFeWXXMAEUM3J.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/4mwD1ttJrh",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 236,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1788638758465646593"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 289,
                                "favorited": false,
                                "full_text": "A new sculpture of Cristiano Ronaldo's iconic celebration made out of SAND has appeared in Germany 🏝️😳🐐 https://t.co/4mwD1ttJrh",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 3,
                                "reply_count": 9,
                                "retweet_count": 21,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1788638807320875162"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1778302459540128047",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1778302459540128047"
                                ],
                                "editable_until_msecs": "1712818920000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "9501",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://twitter.com\" rel=\"nofollow\">TweetDeck Web App</a>",
                            "legacy": {
                                "bookmark_count": 3,
                                "bookmarked": false,
                                "created_at": "Thu Apr 11 06:02:00 +0000 2024",
                                "conversation_id_str": "1778302459540128047",
                                "display_text_range": [
                                    0,
                                    219
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/poncnjxy9y",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1778302459540128047/photo/1",
                                            "id_str": "1778181683134500864",
                                            "indices": [
                                                220,
                                                243
                                            ],
                                            "media_key": "3_1778181683134500864",
                                            "media_url_https": "https://pbs.twimg.com/media/GK1e0dFWkAA81vk.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/PonCNjXy9y",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1500,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1500,
                                                "width": 1200,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 1,
                                                        "w": 1200,
                                                        "h": 672
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1200
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1368
                                                    },
                                                    {
                                                        "x": 262,
                                                        "y": 0,
                                                        "w": 750,
                                                        "h": 1500
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1500
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1778181683134500864"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/PonCNjXy9y",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1778302459540128047/photo/1",
                                            "id_str": "1778181683134500864",
                                            "indices": [
                                                220,
                                                243
                                            ],
                                            "media_key": "3_1778181683134500864",
                                            "media_url_https": "https://pbs.twimg.com/media/GK1e0dFWkAA81vk.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/PonCNjXy9y",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1500,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1500,
                                                "width": 1200,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 1,
                                                        "w": 1200,
                                                        "h": 672
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1200
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1368
                                                    },
                                                    {
                                                        "x": 262,
                                                        "y": 0,
                                                        "w": 750,
                                                        "h": 1500
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1500
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1778181683134500864"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 273,
                                "favorited": false,
                                "full_text": "🗣️ Kylian Mbappé before the Barcelona game: \"I am ready and, as always, I am not going to hide.\"\n\n😳 0 shots on target\n🤨 1 take-on\n😫 13 losses of possession\n\nIt may have also been his last UCL game at the Parc for PSG 🏟️ https://t.co/PonCNjXy9y",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 1,
                                "reply_count": 6,
                                "retweet_count": 21,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1778302459540128047"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1775939136836235711",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1775939136836235711"
                                ],
                                "editable_until_msecs": "1712255460000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "9367",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                            "legacy": {
                                "bookmark_count": 2,
                                "bookmarked": false,
                                "created_at": "Thu Apr 04 17:31:00 +0000 2024",
                                "conversation_id_str": "1775939136836235711",
                                "display_text_range": [
                                    0,
                                    216
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/64dnuelzwh",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1775939136836235711/photo/1",
                                            "id_str": "1775864314487873537",
                                            "indices": [
                                                217,
                                                240
                                            ],
                                            "media_key": "3_1775864314487873537",
                                            "media_url_https": "https://pbs.twimg.com/media/GKUjL2JXoAE5fz3.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/64DnUElZWH",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 291,
                                                            "y": 1107,
                                                            "h": 222,
                                                            "w": 222
                                                        },
                                                        {
                                                            "x": 371,
                                                            "y": 180,
                                                            "h": 363,
                                                            "w": 363
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 258,
                                                            "y": 984,
                                                            "h": 197,
                                                            "w": 197
                                                        },
                                                        {
                                                            "x": 329,
                                                            "y": 160,
                                                            "h": 322,
                                                            "w": 322
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 146,
                                                            "y": 557,
                                                            "h": 111,
                                                            "w": 111
                                                        },
                                                        {
                                                            "x": 186,
                                                            "y": 90,
                                                            "h": 182,
                                                            "w": 182
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 291,
                                                            "y": 1107,
                                                            "h": 222,
                                                            "w": 222
                                                        },
                                                        {
                                                            "x": 371,
                                                            "y": 180,
                                                            "h": 363,
                                                            "w": 363
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 69,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 169,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1775864314487873537"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/64DnUElZWH",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1775939136836235711/photo/1",
                                            "id_str": "1775864314487873537",
                                            "indices": [
                                                217,
                                                240
                                            ],
                                            "media_key": "3_1775864314487873537",
                                            "media_url_https": "https://pbs.twimg.com/media/GKUjL2JXoAE5fz3.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/64DnUElZWH",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 291,
                                                            "y": 1107,
                                                            "h": 222,
                                                            "w": 222
                                                        },
                                                        {
                                                            "x": 371,
                                                            "y": 180,
                                                            "h": 363,
                                                            "w": 363
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 258,
                                                            "y": 984,
                                                            "h": 197,
                                                            "w": 197
                                                        },
                                                        {
                                                            "x": 329,
                                                            "y": 160,
                                                            "h": 322,
                                                            "w": 322
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 146,
                                                            "y": 557,
                                                            "h": 111,
                                                            "w": 111
                                                        },
                                                        {
                                                            "x": 186,
                                                            "y": 90,
                                                            "h": 182,
                                                            "w": 182
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 291,
                                                            "y": 1107,
                                                            "h": 222,
                                                            "w": 222
                                                        },
                                                        {
                                                            "x": 371,
                                                            "y": 180,
                                                            "h": 363,
                                                            "w": 363
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 69,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 169,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1775864314487873537"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 203,
                                "favorited": false,
                                "full_text": "Bernardo Silva is considering leaving Manchester City this summer in favour of Barcelona 😱\n\nXavi is said to be a fan of the 29-year-old and he has a special release clause of €58M for Barça, per Mundo Deportivo 🗞️ 🇪🇸 https://t.co/64DnUElZWH",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 5,
                                "reply_count": 9,
                                "retweet_count": 15,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1775939136836235711"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1767902180848366043",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1767902180848366043"
                                ],
                                "editable_until_msecs": "1710339300000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "5521",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                            "legacy": {
                                "bookmark_count": 1,
                                "bookmarked": false,
                                "created_at": "Wed Mar 13 13:15:00 +0000 2024",
                                "conversation_id_str": "1767902180848366043",
                                "display_text_range": [
                                    0,
                                    260
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/5iwncnwxa3",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1767902180848366043/photo/1",
                                            "id_str": "1767892068045565953",
                                            "indices": [
                                                261,
                                                284
                                            ],
                                            "media_key": "3_1767892068045565953",
                                            "media_url_https": "https://pbs.twimg.com/media/GIjQeB0WMAEiQ3K.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/5iWnCNWXA3",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 453,
                                                            "y": 590,
                                                            "h": 89,
                                                            "w": 89
                                                        },
                                                        {
                                                            "x": 450,
                                                            "y": 63,
                                                            "h": 159,
                                                            "w": 159
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 402,
                                                            "y": 524,
                                                            "h": 79,
                                                            "w": 79
                                                        },
                                                        {
                                                            "x": 400,
                                                            "y": 56,
                                                            "h": 141,
                                                            "w": 141
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 228,
                                                            "y": 297,
                                                            "h": 44,
                                                            "w": 44
                                                        },
                                                        {
                                                            "x": 226,
                                                            "y": 31,
                                                            "h": 80,
                                                            "w": 80
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 453,
                                                            "y": 590,
                                                            "h": 89,
                                                            "w": 89
                                                        },
                                                        {
                                                            "x": 450,
                                                            "y": 63,
                                                            "h": 159,
                                                            "w": 159
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 169,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1767892068045565953"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/5iWnCNWXA3",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1767902180848366043/photo/1",
                                            "id_str": "1767892068045565953",
                                            "indices": [
                                                261,
                                                284
                                            ],
                                            "media_key": "3_1767892068045565953",
                                            "media_url_https": "https://pbs.twimg.com/media/GIjQeB0WMAEiQ3K.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/5iWnCNWXA3",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 453,
                                                            "y": 590,
                                                            "h": 89,
                                                            "w": 89
                                                        },
                                                        {
                                                            "x": 450,
                                                            "y": 63,
                                                            "h": 159,
                                                            "w": 159
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 402,
                                                            "y": 524,
                                                            "h": 79,
                                                            "w": 79
                                                        },
                                                        {
                                                            "x": 400,
                                                            "y": 56,
                                                            "h": 141,
                                                            "w": 141
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 228,
                                                            "y": 297,
                                                            "h": 44,
                                                            "w": 44
                                                        },
                                                        {
                                                            "x": 226,
                                                            "y": 31,
                                                            "h": 80,
                                                            "w": 80
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 453,
                                                            "y": 590,
                                                            "h": 89,
                                                            "w": 89
                                                        },
                                                        {
                                                            "x": 450,
                                                            "y": 63,
                                                            "h": 159,
                                                            "w": 159
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 169,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1767892068045565953"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 160,
                                "favorited": false,
                                "full_text": "In 2018, David Raya was playing for Blackburn Rovers in the EFL League One 🔙\n\nIn 2024, He is now at the top of the Premier League with Arsenal and saved 2 penalties against Porto to send them through to the UCL quarter-finals for the first time in 14 years 🙌 🧤 https://t.co/5iWnCNWXA3",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 1,
                                "reply_count": 10,
                                "retweet_count": 16,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1767902180848366043"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1765335529619345822",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1765335529619345822"
                                ],
                                "editable_until_msecs": "1709727363000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "7904",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                            "legacy": {
                                "bookmark_count": 0,
                                "bookmarked": false,
                                "created_at": "Wed Mar 06 11:16:03 +0000 2024",
                                "conversation_id_str": "1765335529619345822",
                                "display_text_range": [
                                    0,
                                    236
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/qxwps7dduh",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1765335529619345822/photo/1",
                                            "id_str": "1765335441455108097",
                                            "indices": [
                                                237,
                                                260
                                            ],
                                            "media_key": "3_1765335441455108097",
                                            "media_url_https": "https://pbs.twimg.com/media/GH-7OxlW0AEAagD.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/QXWpS7Dduh",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 229,
                                                            "y": 462,
                                                            "h": 58,
                                                            "w": 58
                                                        },
                                                        {
                                                            "x": 32,
                                                            "y": 1044,
                                                            "h": 58,
                                                            "w": 58
                                                        },
                                                        {
                                                            "x": 834,
                                                            "y": 251,
                                                            "h": 141,
                                                            "w": 141
                                                        },
                                                        {
                                                            "x": 67,
                                                            "y": 117,
                                                            "h": 159,
                                                            "w": 159
                                                        },
                                                        {
                                                            "x": 350,
                                                            "y": 117,
                                                            "h": 156,
                                                            "w": 156
                                                        },
                                                        {
                                                            "x": 458,
                                                            "y": 150,
                                                            "h": 143,
                                                            "w": 143
                                                        },
                                                        {
                                                            "x": 413,
                                                            "y": 261,
                                                            "h": 133,
                                                            "w": 133
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 203,
                                                            "y": 410,
                                                            "h": 51,
                                                            "w": 51
                                                        },
                                                        {
                                                            "x": 28,
                                                            "y": 928,
                                                            "h": 51,
                                                            "w": 51
                                                        },
                                                        {
                                                            "x": 741,
                                                            "y": 223,
                                                            "h": 125,
                                                            "w": 125
                                                        },
                                                        {
                                                            "x": 59,
                                                            "y": 104,
                                                            "h": 141,
                                                            "w": 141
                                                        },
                                                        {
                                                            "x": 311,
                                                            "y": 104,
                                                            "h": 138,
                                                            "w": 138
                                                        },
                                                        {
                                                            "x": 407,
                                                            "y": 133,
                                                            "h": 127,
                                                            "w": 127
                                                        },
                                                        {
                                                            "x": 367,
                                                            "y": 232,
                                                            "h": 118,
                                                            "w": 118
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 115,
                                                            "y": 232,
                                                            "h": 29,
                                                            "w": 29
                                                        },
                                                        {
                                                            "x": 16,
                                                            "y": 525,
                                                            "h": 29,
                                                            "w": 29
                                                        },
                                                        {
                                                            "x": 420,
                                                            "y": 126,
                                                            "h": 71,
                                                            "w": 71
                                                        },
                                                        {
                                                            "x": 33,
                                                            "y": 58,
                                                            "h": 80,
                                                            "w": 80
                                                        },
                                                        {
                                                            "x": 176,
                                                            "y": 58,
                                                            "h": 78,
                                                            "w": 78
                                                        },
                                                        {
                                                            "x": 230,
                                                            "y": 75,
                                                            "h": 72,
                                                            "w": 72
                                                        },
                                                        {
                                                            "x": 208,
                                                            "y": 131,
                                                            "h": 66,
                                                            "w": 66
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 229,
                                                            "y": 462,
                                                            "h": 58,
                                                            "w": 58
                                                        },
                                                        {
                                                            "x": 32,
                                                            "y": 1044,
                                                            "h": 58,
                                                            "w": 58
                                                        },
                                                        {
                                                            "x": 834,
                                                            "y": 251,
                                                            "h": 141,
                                                            "w": 141
                                                        },
                                                        {
                                                            "x": 67,
                                                            "y": 117,
                                                            "h": 159,
                                                            "w": 159
                                                        },
                                                        {
                                                            "x": 350,
                                                            "y": 117,
                                                            "h": 156,
                                                            "w": 156
                                                        },
                                                        {
                                                            "x": 458,
                                                            "y": 150,
                                                            "h": 143,
                                                            "w": 143
                                                        },
                                                        {
                                                            "x": 413,
                                                            "y": 261,
                                                            "h": 133,
                                                            "w": 133
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 1,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 169,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1765335441455108097"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": [
                                        {
                                            "id_str": "20583737",
                                            "name": "Relevo",
                                            "screen_name": "relevo",
                                            "indices": [
                                                226,
                                                233
                                            ]
                                        }
                                    ]
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/QXWpS7Dduh",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1765335529619345822/photo/1",
                                            "id_str": "1765335441455108097",
                                            "indices": [
                                                237,
                                                260
                                            ],
                                            "media_key": "3_1765335441455108097",
                                            "media_url_https": "https://pbs.twimg.com/media/GH-7OxlW0AEAagD.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/QXWpS7Dduh",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 229,
                                                            "y": 462,
                                                            "h": 58,
                                                            "w": 58
                                                        },
                                                        {
                                                            "x": 32,
                                                            "y": 1044,
                                                            "h": 58,
                                                            "w": 58
                                                        },
                                                        {
                                                            "x": 834,
                                                            "y": 251,
                                                            "h": 141,
                                                            "w": 141
                                                        },
                                                        {
                                                            "x": 67,
                                                            "y": 117,
                                                            "h": 159,
                                                            "w": 159
                                                        },
                                                        {
                                                            "x": 350,
                                                            "y": 117,
                                                            "h": 156,
                                                            "w": 156
                                                        },
                                                        {
                                                            "x": 458,
                                                            "y": 150,
                                                            "h": 143,
                                                            "w": 143
                                                        },
                                                        {
                                                            "x": 413,
                                                            "y": 261,
                                                            "h": 133,
                                                            "w": 133
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 203,
                                                            "y": 410,
                                                            "h": 51,
                                                            "w": 51
                                                        },
                                                        {
                                                            "x": 28,
                                                            "y": 928,
                                                            "h": 51,
                                                            "w": 51
                                                        },
                                                        {
                                                            "x": 741,
                                                            "y": 223,
                                                            "h": 125,
                                                            "w": 125
                                                        },
                                                        {
                                                            "x": 59,
                                                            "y": 104,
                                                            "h": 141,
                                                            "w": 141
                                                        },
                                                        {
                                                            "x": 311,
                                                            "y": 104,
                                                            "h": 138,
                                                            "w": 138
                                                        },
                                                        {
                                                            "x": 407,
                                                            "y": 133,
                                                            "h": 127,
                                                            "w": 127
                                                        },
                                                        {
                                                            "x": 367,
                                                            "y": 232,
                                                            "h": 118,
                                                            "w": 118
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 115,
                                                            "y": 232,
                                                            "h": 29,
                                                            "w": 29
                                                        },
                                                        {
                                                            "x": 16,
                                                            "y": 525,
                                                            "h": 29,
                                                            "w": 29
                                                        },
                                                        {
                                                            "x": 420,
                                                            "y": 126,
                                                            "h": 71,
                                                            "w": 71
                                                        },
                                                        {
                                                            "x": 33,
                                                            "y": 58,
                                                            "h": 80,
                                                            "w": 80
                                                        },
                                                        {
                                                            "x": 176,
                                                            "y": 58,
                                                            "h": 78,
                                                            "w": 78
                                                        },
                                                        {
                                                            "x": 230,
                                                            "y": 75,
                                                            "h": 72,
                                                            "w": 72
                                                        },
                                                        {
                                                            "x": 208,
                                                            "y": 131,
                                                            "h": 66,
                                                            "w": 66
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 229,
                                                            "y": 462,
                                                            "h": 58,
                                                            "w": 58
                                                        },
                                                        {
                                                            "x": 32,
                                                            "y": 1044,
                                                            "h": 58,
                                                            "w": 58
                                                        },
                                                        {
                                                            "x": 834,
                                                            "y": 251,
                                                            "h": 141,
                                                            "w": 141
                                                        },
                                                        {
                                                            "x": 67,
                                                            "y": 117,
                                                            "h": 159,
                                                            "w": 159
                                                        },
                                                        {
                                                            "x": 350,
                                                            "y": 117,
                                                            "h": 156,
                                                            "w": 156
                                                        },
                                                        {
                                                            "x": 458,
                                                            "y": 150,
                                                            "h": 143,
                                                            "w": 143
                                                        },
                                                        {
                                                            "x": 413,
                                                            "y": 261,
                                                            "h": 133,
                                                            "w": 133
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 1,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 169,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1765335441455108097"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 102,
                                "favorited": false,
                                "full_text": "🟥 LaLiga has suspended Jude Bellingham for two games following his red card against Valencia 👀\n\nThe reason for the suspension is “attitudes of contempt or inconsideration towards referees, managers or sports authorities,” per @relevo 🗞️ https://t.co/QXWpS7Dduh",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 2,
                                "reply_count": 9,
                                "retweet_count": 8,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1765335529619345822"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1762775781380337996",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1762775781380337996"
                                ],
                                "editable_until_msecs": "1709117071000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "7394",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"http://twitter.com/download/iphone\" rel=\"nofollow\">Twitter for iPhone</a>",
                            "note_tweet": {
                                "is_expandable": true,
                                "note_tweet_results": {
                                    "result": {
                                        "id": "Tm90ZVR3ZWV0OjE3NjI3NzU3ODEyNzk3NjAzODQ=",
                                        "text": "Laliga President Javier Tebas believes Kylian Mbappé has already signed for Real Madrid 🥵👇\n\n🗣️ “I have feeling that Kylian Mbappé has signed for Real Madrid. He’ll be another star in La Liga like Bellingham, Vinicius Jr, Griezmann, and Lewandowski.\n\n💪 “Madrid have been very prudent financially and have prepared for the signing of Mbappe. Their strategy is not short-term.\n\n🙅‍♂️ “They don’t have to sell anyone to afford Mbappe. They really don’t.”",
                                        "entity_set": {
                                            "hashtags": [],
                                            "symbols": [],
                                            "timestamps": [],
                                            "urls": [],
                                            "user_mentions": []
                                        }
                                    }
                                }
                            },
                            "legacy": {
                                "bookmark_count": 1,
                                "bookmarked": false,
                                "created_at": "Wed Feb 28 09:44:31 +0000 2024",
                                "conversation_id_str": "1762775781380337996",
                                "display_text_range": [
                                    0,
                                    274
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/cfzbkz0rm8",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1762775781380337996/photo/1",
                                            "id_str": "1762775769455964160",
                                            "indices": [
                                                275,
                                                298
                                            ],
                                            "media_key": "3_1762775769455964160",
                                            "media_url_https": "https://pbs.twimg.com/media/GHajOQUWsAAF42n.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/CFzbkz0Rm8",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 712,
                                                            "y": 384,
                                                            "h": 356,
                                                            "w": 356
                                                        },
                                                        {
                                                            "x": 908,
                                                            "y": 640,
                                                            "h": 388,
                                                            "w": 388
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 417,
                                                            "y": 225,
                                                            "h": 208,
                                                            "w": 208
                                                        },
                                                        {
                                                            "x": 532,
                                                            "y": 375,
                                                            "h": 227,
                                                            "w": 227
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 236,
                                                            "y": 127,
                                                            "h": 118,
                                                            "w": 118
                                                        },
                                                        {
                                                            "x": 301,
                                                            "y": 212,
                                                            "h": 128,
                                                            "w": 128
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 712,
                                                            "y": 384,
                                                            "h": 356,
                                                            "w": 356
                                                        },
                                                        {
                                                            "x": 908,
                                                            "y": 640,
                                                            "h": 388,
                                                            "w": 388
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 2048,
                                                    "w": 1638,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 2048,
                                                "width": 1638,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 719,
                                                        "w": 1638,
                                                        "h": 917
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 358,
                                                        "w": 1638,
                                                        "h": 1638
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 181,
                                                        "w": 1638,
                                                        "h": 1867
                                                    },
                                                    {
                                                        "x": 460,
                                                        "y": 0,
                                                        "w": 1024,
                                                        "h": 2048
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1638,
                                                        "h": 2048
                                                    }
                                                ]
                                            },
                                            "allow_download_status": {
                                                "allow_download": true
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1762775769455964160"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/CFzbkz0Rm8",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1762775781380337996/photo/1",
                                            "id_str": "1762775769455964160",
                                            "indices": [
                                                275,
                                                298
                                            ],
                                            "media_key": "3_1762775769455964160",
                                            "media_url_https": "https://pbs.twimg.com/media/GHajOQUWsAAF42n.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/CFzbkz0Rm8",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 712,
                                                            "y": 384,
                                                            "h": 356,
                                                            "w": 356
                                                        },
                                                        {
                                                            "x": 908,
                                                            "y": 640,
                                                            "h": 388,
                                                            "w": 388
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 417,
                                                            "y": 225,
                                                            "h": 208,
                                                            "w": 208
                                                        },
                                                        {
                                                            "x": 532,
                                                            "y": 375,
                                                            "h": 227,
                                                            "w": 227
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 236,
                                                            "y": 127,
                                                            "h": 118,
                                                            "w": 118
                                                        },
                                                        {
                                                            "x": 301,
                                                            "y": 212,
                                                            "h": 128,
                                                            "w": 128
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 712,
                                                            "y": 384,
                                                            "h": 356,
                                                            "w": 356
                                                        },
                                                        {
                                                            "x": 908,
                                                            "y": 640,
                                                            "h": 388,
                                                            "w": 388
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 2048,
                                                    "w": 1638,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 2048,
                                                "width": 1638,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 719,
                                                        "w": 1638,
                                                        "h": 917
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 358,
                                                        "w": 1638,
                                                        "h": 1638
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 181,
                                                        "w": 1638,
                                                        "h": 1867
                                                    },
                                                    {
                                                        "x": 460,
                                                        "y": 0,
                                                        "w": 1024,
                                                        "h": 2048
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1638,
                                                        "h": 2048
                                                    }
                                                ]
                                            },
                                            "allow_download_status": {
                                                "allow_download": true
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1762775769455964160"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 97,
                                "favorited": false,
                                "full_text": "Laliga President Javier Tebas believes Kylian Mbappé has already signed for Real Madrid 🥵👇\n\n🗣️ “I have feeling that Kylian Mbappé has signed for Real Madrid. He’ll be another star in La Liga like Bellingham, Vinicius Jr, Griezmann, and Lewandowski.\n\n💪 “Madrid have been very https://t.co/CFzbkz0Rm8",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 1,
                                "reply_count": 2,
                                "retweet_count": 10,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1762775781380337996"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1761053900159750624",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1761053900159750624"
                                ],
                                "editable_until_msecs": "1708706543000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "10693",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                            "note_tweet": {
                                "is_expandable": true,
                                "note_tweet_results": {
                                    "result": {
                                        "id": "Tm90ZVR3ZWV0OjE3NjEwNTM5MDAwNzU5MDA5Mjk=",
                                        "text": "Pep Guardiola has admitted he'd be open to taking over a national team 😳 🏆 👇\n\n🗣️  \"I would like to experience living through a World Cup, a Euro Cup, a  Copa America, whatever it may be. I would like to experience that. I  don't know when, in five, ten, fifteen years, but I would like to play  in a World Cup as a coach\" per ESPN 😍",
                                        "entity_set": {
                                            "hashtags": [],
                                            "symbols": [],
                                            "urls": [],
                                            "user_mentions": []
                                        },
                                        "richtext": {
                                            "richtext_tags": []
                                        },
                                        "media": {
                                            "inline_media": []
                                        }
                                    }
                                }
                            },
                            "legacy": {
                                "bookmark_count": 3,
                                "bookmarked": false,
                                "created_at": "Fri Feb 23 15:42:23 +0000 2024",
                                "conversation_id_str": "1761053900159750624",
                                "display_text_range": [
                                    0,
                                    274
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/2dickttqxd",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1761053900159750624/photo/1",
                                            "id_str": "1761053895344717824",
                                            "indices": [
                                                275,
                                                298
                                            ],
                                            "media_key": "3_1761053895344717824",
                                            "media_url_https": "https://pbs.twimg.com/media/GHCFL_ZXAAAv23D.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/2diCKtTqxd",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 401,
                                                            "y": 670,
                                                            "h": 62,
                                                            "w": 62
                                                        },
                                                        {
                                                            "x": 147,
                                                            "y": 203,
                                                            "h": 315,
                                                            "w": 315
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 401,
                                                            "y": 670,
                                                            "h": 62,
                                                            "w": 62
                                                        },
                                                        {
                                                            "x": 147,
                                                            "y": 203,
                                                            "h": 315,
                                                            "w": 315
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 227,
                                                            "y": 379,
                                                            "h": 35,
                                                            "w": 35
                                                        },
                                                        {
                                                            "x": 83,
                                                            "y": 115,
                                                            "h": 178,
                                                            "w": 178
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 401,
                                                            "y": 670,
                                                            "h": 62,
                                                            "w": 62
                                                        },
                                                        {
                                                            "x": 147,
                                                            "y": 203,
                                                            "h": 315,
                                                            "w": 315
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1200,
                                                "width": 960,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 121,
                                                        "w": 960,
                                                        "h": 538
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 960,
                                                        "h": 960
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 960,
                                                        "h": 1094
                                                    },
                                                    {
                                                        "x": 30,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 1200
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 960,
                                                        "h": 1200
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1761053895344717824"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/2diCKtTqxd",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1761053900159750624/photo/1",
                                            "id_str": "1761053895344717824",
                                            "indices": [
                                                275,
                                                298
                                            ],
                                            "media_key": "3_1761053895344717824",
                                            "media_url_https": "https://pbs.twimg.com/media/GHCFL_ZXAAAv23D.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/2diCKtTqxd",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 401,
                                                            "y": 670,
                                                            "h": 62,
                                                            "w": 62
                                                        },
                                                        {
                                                            "x": 147,
                                                            "y": 203,
                                                            "h": 315,
                                                            "w": 315
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 401,
                                                            "y": 670,
                                                            "h": 62,
                                                            "w": 62
                                                        },
                                                        {
                                                            "x": 147,
                                                            "y": 203,
                                                            "h": 315,
                                                            "w": 315
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 227,
                                                            "y": 379,
                                                            "h": 35,
                                                            "w": 35
                                                        },
                                                        {
                                                            "x": 83,
                                                            "y": 115,
                                                            "h": 178,
                                                            "w": 178
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 401,
                                                            "y": 670,
                                                            "h": 62,
                                                            "w": 62
                                                        },
                                                        {
                                                            "x": 147,
                                                            "y": 203,
                                                            "h": 315,
                                                            "w": 315
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1200,
                                                "width": 960,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 121,
                                                        "w": 960,
                                                        "h": 538
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 960,
                                                        "h": 960
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 960,
                                                        "h": 1094
                                                    },
                                                    {
                                                        "x": 30,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 1200
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 960,
                                                        "h": 1200
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1761053895344717824"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 167,
                                "favorited": false,
                                "full_text": "Pep Guardiola has admitted he'd be open to taking over a national team 😳 🏆 👇\n\n🗣️  \"I would like to experience living through a World Cup, a Euro Cup, a  Copa America, whatever it may be. I would like to experience that. I  don't know when, in five, ten, fifteen years, but I https://t.co/2diCKtTqxd",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 4,
                                "reply_count": 16,
                                "retweet_count": 16,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1761053900159750624"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1760454605392277942",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1760454605392277942"
                                ],
                                "editable_until_msecs": "1708563660000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "8421",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                            "legacy": {
                                "bookmark_count": 3,
                                "bookmarked": false,
                                "created_at": "Thu Feb 22 00:01:00 +0000 2024",
                                "conversation_id_str": "1760454605392277942",
                                "display_text_range": [
                                    0,
                                    230
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/we6pjijaef",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1760454605392277942/photo/1",
                                            "id_str": "1760351426964770816",
                                            "indices": [
                                                231,
                                                254
                                            ],
                                            "media_key": "3_1760351426964770816",
                                            "media_url_https": "https://pbs.twimg.com/media/GG4GS8wWUAApALJ.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/we6pjijAEf",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 180,
                                                            "y": 213,
                                                            "h": 391,
                                                            "w": 391
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 160,
                                                            "y": 189,
                                                            "h": 347,
                                                            "w": 347
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 90,
                                                            "y": 107,
                                                            "h": 196,
                                                            "w": 196
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 180,
                                                            "y": 213,
                                                            "h": 391,
                                                            "w": 391
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 136,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 101,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1760351426964770816"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.x.com/we6pjijaef",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1760454605392277942/photo/1",
                                            "id_str": "1760351426943787009",
                                            "indices": [
                                                231,
                                                254
                                            ],
                                            "media_key": "3_1760351426943787009",
                                            "media_url_https": "https://pbs.twimg.com/media/GG4GS8rWIAEYMix.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/we6pjijAEf",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 474,
                                                            "y": 858,
                                                            "h": 50,
                                                            "w": 50
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 421,
                                                            "y": 762,
                                                            "h": 44,
                                                            "w": 44
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 238,
                                                            "y": 432,
                                                            "h": 25,
                                                            "w": 25
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 474,
                                                            "y": 858,
                                                            "h": 50,
                                                            "w": 50
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 136,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 169,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1760351426943787009"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/we6pjijAEf",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1760454605392277942/photo/1",
                                            "id_str": "1760351426964770816",
                                            "indices": [
                                                231,
                                                254
                                            ],
                                            "media_key": "3_1760351426964770816",
                                            "media_url_https": "https://pbs.twimg.com/media/GG4GS8wWUAApALJ.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/we6pjijAEf",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 180,
                                                            "y": 213,
                                                            "h": 391,
                                                            "w": 391
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 160,
                                                            "y": 189,
                                                            "h": 347,
                                                            "w": 347
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 90,
                                                            "y": 107,
                                                            "h": 196,
                                                            "w": 196
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 180,
                                                            "y": 213,
                                                            "h": 391,
                                                            "w": 391
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 136,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 101,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1760351426964770816"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.twitter.com/we6pjijAEf",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1760454605392277942/photo/1",
                                            "id_str": "1760351426943787009",
                                            "indices": [
                                                231,
                                                254
                                            ],
                                            "media_key": "3_1760351426943787009",
                                            "media_url_https": "https://pbs.twimg.com/media/GG4GS8rWIAEYMix.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/we6pjijAEf",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 474,
                                                            "y": 858,
                                                            "h": 50,
                                                            "w": 50
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 421,
                                                            "y": 762,
                                                            "h": 44,
                                                            "w": 44
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 238,
                                                            "y": 432,
                                                            "h": 25,
                                                            "w": 25
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 474,
                                                            "y": 858,
                                                            "h": 50,
                                                            "w": 50
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 136,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 169,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1760351426943787009"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 189,
                                "favorited": false,
                                "full_text": "The MLS season kicks off with Inter Miami playing host to Real Salt Lake 🍿\n\nThe last time Lionel Messi, Luis Suarez, Sergio Busquets and Jordi Alba played a competitive game together❓🤔\n\nAn 8-2 demolition at the hands of Bayern...😬 https://t.co/we6pjijAEf",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 1,
                                "reply_count": 5,
                                "retweet_count": 15,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1760454605392277942"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1758114242970980375",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1758114242970980375"
                                ],
                                "editable_until_msecs": "1708005674000",
                                "is_edit_eligible": false,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "5947",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                            "note_tweet": {
                                "is_expandable": true,
                                "note_tweet_results": {
                                    "result": {
                                        "id": "Tm90ZVR3ZWV0OjE3NTgxMTQyNDI4NjYxMzkxMzY=",
                                        "text": "Wayne Rooney is 'in early talks' with Misfits Boxing and over a possible one-off fight, according to Mirror Sport 👀🥊\n\nIn December 2022, Misfits founder KSI confirmed in a press conference that Rooney had challenged him to a boxing fight:\n\n🗣️\"It's funny, and I hope he doesn't get annoyed that I'm saying this, but Wayne Rooney hit me up saying 'oh we should fight'...",
                                        "entity_set": {
                                            "hashtags": [],
                                            "symbols": [],
                                            "urls": [],
                                            "user_mentions": []
                                        },
                                        "richtext": {
                                            "richtext_tags": []
                                        },
                                        "media": {
                                            "inline_media": []
                                        }
                                    }
                                }
                            },
                            "legacy": {
                                "bookmark_count": 0,
                                "bookmarked": false,
                                "created_at": "Thu Feb 15 13:01:14 +0000 2024",
                                "conversation_id_str": "1758114242970980375",
                                "display_text_range": [
                                    0,
                                    275
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/nptr4jsaty",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1758114242970980375/photo/1",
                                            "id_str": "1758114166852698112",
                                            "indices": [
                                                276,
                                                299
                                            ],
                                            "media_key": "3_1758114166852698112",
                                            "media_url_https": "https://pbs.twimg.com/media/GGYThRXWQAARD4R.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/NPtr4jSAty",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 581,
                                                            "y": 110,
                                                            "h": 92,
                                                            "w": 92
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 516,
                                                            "y": 97,
                                                            "h": 81,
                                                            "w": 81
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 292,
                                                            "y": 55,
                                                            "h": 46,
                                                            "w": 46
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 581,
                                                            "y": 110,
                                                            "h": 92,
                                                            "w": 92
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 405,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1758114166852698112"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/NPtr4jSAty",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1758114242970980375/photo/1",
                                            "id_str": "1758114166852698112",
                                            "indices": [
                                                276,
                                                299
                                            ],
                                            "media_key": "3_1758114166852698112",
                                            "media_url_https": "https://pbs.twimg.com/media/GGYThRXWQAARD4R.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/NPtr4jSAty",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 581,
                                                            "y": 110,
                                                            "h": 92,
                                                            "w": 92
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 516,
                                                            "y": 97,
                                                            "h": 81,
                                                            "w": 81
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 292,
                                                            "y": 55,
                                                            "h": 46,
                                                            "w": 46
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 581,
                                                            "y": 110,
                                                            "h": 92,
                                                            "w": 92
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 405,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1758114166852698112"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 40,
                                "favorited": false,
                                "full_text": "Wayne Rooney is 'in early talks' with Misfits Boxing and over a possible one-off fight, according to Mirror Sport 👀🥊\n\nIn December 2022, Misfits founder KSI confirmed in a press conference that Rooney had challenged him to a boxing fight:\n\n🗣️\"It's funny, and I hope he doesn't https://t.co/NPtr4jSAty",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 0,
                                "reply_count": 3,
                                "retweet_count": 0,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1758114242970980375"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1757499973174743306",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1757499973174743306"
                                ],
                                "editable_until_msecs": "1707859221000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "7454",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                            "note_tweet": {
                                "is_expandable": true,
                                "note_tweet_results": {
                                    "result": {
                                        "id": "Tm90ZVR3ZWV0OjE3NTc0OTk5NzMwOTA5MDIwMTY=",
                                        "text": "Kevin De Bruyne really is the biggest of big game players 😤\n\nHis last 10 Champions League goals have all been scored in the knock-out stages 🥊\n\n⚽️ RO16 vs Real Madrid\n⚽️ QF vs Lyon\n⚽️ RO16 vs Gladbach\n⚽️ QF vs Dortmund\n⚽️ SF vs PSG\n⚽️ QF vs Atlético\n⚽️ SF vs Real Madrid\n⚽️ RO16 vs RB Leipzig\n⚽️ SF vs Real Madrid\n⚽️ RO16 vs Copenhagen",
                                        "entity_set": {
                                            "hashtags": [],
                                            "symbols": [],
                                            "urls": [],
                                            "user_mentions": []
                                        },
                                        "richtext": {
                                            "richtext_tags": [
                                                {
                                                    "from_index": 30,
                                                    "to_index": 37,
                                                    "richtext_types": [
                                                        "Bold"
                                                    ]
                                                },
                                                {
                                                    "from_index": 71,
                                                    "to_index": 73,
                                                    "richtext_types": [
                                                        "Bold"
                                                    ]
                                                }
                                            ]
                                        },
                                        "media": {
                                            "inline_media": []
                                        }
                                    }
                                }
                            },
                            "legacy": {
                                "bookmark_count": 5,
                                "bookmarked": false,
                                "created_at": "Tue Feb 13 20:20:21 +0000 2024",
                                "conversation_id_str": "1757499973174743306",
                                "display_text_range": [
                                    0,
                                    278
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/nb9wdri7y3",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1757499973174743306/photo/1",
                                            "id_str": "1757499963066511360",
                                            "indices": [
                                                279,
                                                302
                                            ],
                                            "media_key": "3_1757499963066511360",
                                            "media_url_https": "https://pbs.twimg.com/media/GGPk559XcAA8qFq.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/nb9wDrI7y3",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 398,
                                                            "y": 122,
                                                            "h": 168,
                                                            "w": 168
                                                        },
                                                        {
                                                            "x": 684,
                                                            "y": 908,
                                                            "h": 189,
                                                            "w": 189
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 353,
                                                            "y": 108,
                                                            "h": 149,
                                                            "w": 149
                                                        },
                                                        {
                                                            "x": 608,
                                                            "y": 807,
                                                            "h": 168,
                                                            "w": 168
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 200,
                                                            "y": 61,
                                                            "h": 84,
                                                            "w": 84
                                                        },
                                                        {
                                                            "x": 344,
                                                            "y": 457,
                                                            "h": 95,
                                                            "w": 95
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 398,
                                                            "y": 122,
                                                            "h": 168,
                                                            "w": 168
                                                        },
                                                        {
                                                            "x": 684,
                                                            "y": 908,
                                                            "h": 189,
                                                            "w": 189
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 169,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1757499963066511360"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/nb9wDrI7y3",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1757499973174743306/photo/1",
                                            "id_str": "1757499963066511360",
                                            "indices": [
                                                279,
                                                302
                                            ],
                                            "media_key": "3_1757499963066511360",
                                            "media_url_https": "https://pbs.twimg.com/media/GGPk559XcAA8qFq.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/nb9wDrI7y3",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 398,
                                                            "y": 122,
                                                            "h": 168,
                                                            "w": 168
                                                        },
                                                        {
                                                            "x": 684,
                                                            "y": 908,
                                                            "h": 189,
                                                            "w": 189
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 353,
                                                            "y": 108,
                                                            "h": 149,
                                                            "w": 149
                                                        },
                                                        {
                                                            "x": 608,
                                                            "y": 807,
                                                            "h": 168,
                                                            "w": 168
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 200,
                                                            "y": 61,
                                                            "h": 84,
                                                            "w": 84
                                                        },
                                                        {
                                                            "x": 344,
                                                            "y": 457,
                                                            "h": 95,
                                                            "w": 95
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 398,
                                                            "y": 122,
                                                            "h": 168,
                                                            "w": 168
                                                        },
                                                        {
                                                            "x": 684,
                                                            "y": 908,
                                                            "h": 189,
                                                            "w": 189
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 169,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1757499963066511360"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 86,
                                "favorited": false,
                                "full_text": "Kevin De Bruyne really is the biggest of big game players 😤\n\nHis last 10 Champions League goals have all been scored in the knock-out stages 🥊\n\n⚽️ RO16 vs Real Madrid\n⚽️ QF vs Lyon\n⚽️ RO16 vs Gladbach\n⚽️ QF vs Dortmund\n⚽️ SF vs PSG\n⚽️ QF vs Atlético\n⚽️ SF vs Real Madrid\n⚽️ RO16 https://t.co/nb9wDrI7y3",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 1,
                                "reply_count": 7,
                                "retweet_count": 7,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1757499973174743306"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1755305821783703651",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1755305821783703651"
                                ],
                                "editable_until_msecs": "1707336094000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "6638",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                            "note_tweet": {
                                "is_expandable": true,
                                "note_tweet_results": {
                                    "result": {
                                        "id": "Tm90ZVR3ZWV0OjE3NTUzMDU4MjE2ODcyMDE3OTQ=",
                                        "text": "UNREAL SCENES in the AFCON Semi-Final between Nigeria and South Africa:\n\n85' - Victor Osimhen scores to put Nigeria 2-0 up ⚽️\n\n86' - The goal is disallowed and VAR rules a penalty kick for South Africa for an incident at the other end of the pitch ❌\n\n89' - Teboho Mokoena converts the penalty to send the game to extra time 🤝\n\nThe beauty of this game  🇳🇬 🌍 🇿🇦",
                                        "entity_set": {
                                            "hashtags": [],
                                            "symbols": [],
                                            "urls": [],
                                            "user_mentions": []
                                        },
                                        "richtext": {
                                            "richtext_tags": []
                                        },
                                        "media": {
                                            "inline_media": []
                                        }
                                    }
                                }
                            },
                            "legacy": {
                                "bookmark_count": 0,
                                "bookmarked": false,
                                "created_at": "Wed Feb 07 19:01:34 +0000 2024",
                                "conversation_id_str": "1755305821783703651",
                                "display_text_range": [
                                    0,
                                    271
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/cbi01yfyb6",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1755305821783703651/photo/1",
                                            "id_str": "1755305813428617216",
                                            "indices": [
                                                272,
                                                295
                                            ],
                                            "media_key": "3_1755305813428617216",
                                            "media_url_https": "https://pbs.twimg.com/media/GFwZVlmXQAAazUn.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/CBi01YFYB6",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 424,
                                                            "y": 777,
                                                            "h": 52,
                                                            "w": 52
                                                        },
                                                        {
                                                            "x": 822,
                                                            "y": 796,
                                                            "h": 55,
                                                            "w": 55
                                                        },
                                                        {
                                                            "x": 800,
                                                            "y": 185,
                                                            "h": 195,
                                                            "w": 195
                                                        },
                                                        {
                                                            "x": 346,
                                                            "y": 116,
                                                            "h": 224,
                                                            "w": 224
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 376,
                                                            "y": 690,
                                                            "h": 46,
                                                            "w": 46
                                                        },
                                                        {
                                                            "x": 730,
                                                            "y": 707,
                                                            "h": 48,
                                                            "w": 48
                                                        },
                                                        {
                                                            "x": 711,
                                                            "y": 164,
                                                            "h": 173,
                                                            "w": 173
                                                        },
                                                        {
                                                            "x": 307,
                                                            "y": 103,
                                                            "h": 199,
                                                            "w": 199
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 213,
                                                            "y": 391,
                                                            "h": 26,
                                                            "w": 26
                                                        },
                                                        {
                                                            "x": 414,
                                                            "y": 400,
                                                            "h": 27,
                                                            "w": 27
                                                        },
                                                        {
                                                            "x": 402,
                                                            "y": 93,
                                                            "h": 98,
                                                            "w": 98
                                                        },
                                                        {
                                                            "x": 174,
                                                            "y": 58,
                                                            "h": 112,
                                                            "w": 112
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 424,
                                                            "y": 777,
                                                            "h": 52,
                                                            "w": 52
                                                        },
                                                        {
                                                            "x": 822,
                                                            "y": 796,
                                                            "h": 55,
                                                            "w": 55
                                                        },
                                                        {
                                                            "x": 800,
                                                            "y": 185,
                                                            "h": 195,
                                                            "w": 195
                                                        },
                                                        {
                                                            "x": 346,
                                                            "y": 116,
                                                            "h": 224,
                                                            "w": 224
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 101,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1755305813428617216"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/CBi01YFYB6",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1755305821783703651/photo/1",
                                            "id_str": "1755305813428617216",
                                            "indices": [
                                                272,
                                                295
                                            ],
                                            "media_key": "3_1755305813428617216",
                                            "media_url_https": "https://pbs.twimg.com/media/GFwZVlmXQAAazUn.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/CBi01YFYB6",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 424,
                                                            "y": 777,
                                                            "h": 52,
                                                            "w": 52
                                                        },
                                                        {
                                                            "x": 822,
                                                            "y": 796,
                                                            "h": 55,
                                                            "w": 55
                                                        },
                                                        {
                                                            "x": 800,
                                                            "y": 185,
                                                            "h": 195,
                                                            "w": 195
                                                        },
                                                        {
                                                            "x": 346,
                                                            "y": 116,
                                                            "h": 224,
                                                            "w": 224
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 376,
                                                            "y": 690,
                                                            "h": 46,
                                                            "w": 46
                                                        },
                                                        {
                                                            "x": 730,
                                                            "y": 707,
                                                            "h": 48,
                                                            "w": 48
                                                        },
                                                        {
                                                            "x": 711,
                                                            "y": 164,
                                                            "h": 173,
                                                            "w": 173
                                                        },
                                                        {
                                                            "x": 307,
                                                            "y": 103,
                                                            "h": 199,
                                                            "w": 199
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 213,
                                                            "y": 391,
                                                            "h": 26,
                                                            "w": 26
                                                        },
                                                        {
                                                            "x": 414,
                                                            "y": 400,
                                                            "h": 27,
                                                            "w": 27
                                                        },
                                                        {
                                                            "x": 402,
                                                            "y": 93,
                                                            "h": 98,
                                                            "w": 98
                                                        },
                                                        {
                                                            "x": 174,
                                                            "y": 58,
                                                            "h": 112,
                                                            "w": 112
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 424,
                                                            "y": 777,
                                                            "h": 52,
                                                            "w": 52
                                                        },
                                                        {
                                                            "x": 822,
                                                            "y": 796,
                                                            "h": 55,
                                                            "w": 55
                                                        },
                                                        {
                                                            "x": 800,
                                                            "y": 185,
                                                            "h": 195,
                                                            "w": 195
                                                        },
                                                        {
                                                            "x": 346,
                                                            "y": 116,
                                                            "h": 224,
                                                            "w": 224
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 101,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1755305813428617216"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 69,
                                "favorited": false,
                                "full_text": "UNREAL SCENES in the AFCON Semi-Final between Nigeria and South Africa:\n\n85' - Victor Osimhen scores to put Nigeria 2-0 up ⚽️\n\n86' - The goal is disallowed and VAR rules a penalty kick for South Africa for an incident at the other end of the pitch ❌\n\n89' - Teboho Mokoena https://t.co/CBi01YFYB6",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 0,
                                "reply_count": 0,
                                "retweet_count": 1,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1755305821783703651"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1748873041369862594",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1748873041369862594"
                                ],
                                "editable_until_msecs": "1705802400000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "17681",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                            "legacy": {
                                "bookmark_count": 12,
                                "bookmarked": false,
                                "created_at": "Sun Jan 21 01:00:00 +0000 2024",
                                "conversation_id_str": "1748873041369862594",
                                "display_text_range": [
                                    0,
                                    226
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/edr00x8tbt",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1748873041369862594/photo/1",
                                            "id_str": "1748841602712313858",
                                            "indices": [
                                                227,
                                                250
                                            ],
                                            "media_key": "3_1748841602712313858",
                                            "media_url_https": "https://pbs.twimg.com/media/GEUiLAIXoAI6Flo.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/EdR00x8Tbt",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 127,
                                                            "y": 205,
                                                            "h": 485,
                                                            "w": 485
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 112,
                                                            "y": 182,
                                                            "h": 431,
                                                            "w": 431
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 63,
                                                            "y": 103,
                                                            "h": 244,
                                                            "w": 244
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 127,
                                                            "y": 205,
                                                            "h": 485,
                                                            "w": 485
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 676,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 270,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 119,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 236,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1748841602712313858"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/EdR00x8Tbt",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1748873041369862594/photo/1",
                                            "id_str": "1748841602712313858",
                                            "indices": [
                                                227,
                                                250
                                            ],
                                            "media_key": "3_1748841602712313858",
                                            "media_url_https": "https://pbs.twimg.com/media/GEUiLAIXoAI6Flo.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/EdR00x8Tbt",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 127,
                                                            "y": 205,
                                                            "h": 485,
                                                            "w": 485
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 112,
                                                            "y": 182,
                                                            "h": 431,
                                                            "w": 431
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 63,
                                                            "y": 103,
                                                            "h": 244,
                                                            "w": 244
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 127,
                                                            "y": 205,
                                                            "h": 485,
                                                            "w": 485
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 676,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 270,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 119,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 236,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1748841602712313858"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 510,
                                "favorited": false,
                                "full_text": "🇩🇪 Longest unbeaten runs across all competitions by Bundesliga sides:\n\n◎ 32 - Bayern Munich (2019-2020)\n◎ 27 - Werder Bremen (2003-2004)\n◉ 27 - Bayer Leverkusen (2023-Present)\n\nXabi Alonso is showing no signs of slowing down 💪 https://t.co/EdR00x8Tbt",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 2,
                                "reply_count": 5,
                                "retweet_count": 44,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1748873041369862594"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1723475784696828269",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1723475784696828269"
                                ],
                                "editable_until_msecs": "1699747222000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "16550",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                            "note_tweet": {
                                "is_expandable": true,
                                "note_tweet_results": {
                                    "result": {
                                        "id": "Tm90ZVR3ZWV0OjE3MjM0NzU3ODQ1NzUxNTYyMjQ=",
                                        "text": "😳 Kylian Mbappé in May 2022: “In South America, football is not as advanced as in Europe, that’s why when you look at the last World Cups it’s always Europeans who win.”\n\n🗣️ Copa Liberadores 2023 champion Felipe Melo responded: \"Kylian Mbappé is an idiot.\n\nHe scored three goals in the World Cup final, but Argentina became champions.\n\nHe can’t talk sh*t about South American football. He will win three/four Ballon d’Ors, but he must keep quiet.\n\nThey come from Europe to look for South American players, not in France.” 😤\n\nVia @tntsports",
                                        "entity_set": {
                                            "hashtags": [],
                                            "symbols": [],
                                            "urls": [],
                                            "user_mentions": [
                                                {
                                                    "id_str": "124189302",
                                                    "name": "TNT Sports",
                                                    "screen_name": "tntsports",
                                                    "indices": [
                                                        529,
                                                        539
                                                    ]
                                                }
                                            ]
                                        },
                                        "richtext": {
                                            "richtext_tags": []
                                        },
                                        "media": {
                                            "inline_media": []
                                        }
                                    }
                                }
                            },
                            "legacy": {
                                "bookmark_count": 1,
                                "bookmarked": false,
                                "created_at": "Sat Nov 11 23:00:22 +0000 2023",
                                "conversation_id_str": "1723475784696828269",
                                "display_text_range": [
                                    0,
                                    278
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/b6h91dxz9z",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1723475784696828269/photo/1",
                                            "id_str": "1723475775641251840",
                                            "indices": [
                                                279,
                                                302
                                            ],
                                            "media_key": "3_1723475775641251840",
                                            "media_url_https": "https://pbs.twimg.com/media/F-sEFioWcAAuVPv.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/B6H91DXz9z",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 181,
                                                            "y": 190,
                                                            "h": 429,
                                                            "w": 429
                                                        },
                                                        {
                                                            "x": 613,
                                                            "y": 227,
                                                            "h": 518,
                                                            "w": 518
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 144,
                                                            "y": 152,
                                                            "h": 343,
                                                            "w": 343
                                                        },
                                                        {
                                                            "x": 490,
                                                            "y": 181,
                                                            "h": 414,
                                                            "w": 414
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 82,
                                                            "y": 86,
                                                            "h": 194,
                                                            "w": 194
                                                        },
                                                        {
                                                            "x": 277,
                                                            "y": 102,
                                                            "h": 234,
                                                            "w": 234
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 181,
                                                            "y": 190,
                                                            "h": 429,
                                                            "w": 429
                                                        },
                                                        {
                                                            "x": 613,
                                                            "y": 227,
                                                            "h": 518,
                                                            "w": 518
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1500,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1500,
                                                "width": 1200,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 226,
                                                        "w": 1200,
                                                        "h": 672
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1200
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1368
                                                    },
                                                    {
                                                        "x": 450,
                                                        "y": 0,
                                                        "w": 750,
                                                        "h": 1500
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1500
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1723475775641251840"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/B6H91DXz9z",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1723475784696828269/photo/1",
                                            "id_str": "1723475775641251840",
                                            "indices": [
                                                279,
                                                302
                                            ],
                                            "media_key": "3_1723475775641251840",
                                            "media_url_https": "https://pbs.twimg.com/media/F-sEFioWcAAuVPv.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/B6H91DXz9z",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 181,
                                                            "y": 190,
                                                            "h": 429,
                                                            "w": 429
                                                        },
                                                        {
                                                            "x": 613,
                                                            "y": 227,
                                                            "h": 518,
                                                            "w": 518
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 144,
                                                            "y": 152,
                                                            "h": 343,
                                                            "w": 343
                                                        },
                                                        {
                                                            "x": 490,
                                                            "y": 181,
                                                            "h": 414,
                                                            "w": 414
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 82,
                                                            "y": 86,
                                                            "h": 194,
                                                            "w": 194
                                                        },
                                                        {
                                                            "x": 277,
                                                            "y": 102,
                                                            "h": 234,
                                                            "w": 234
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 181,
                                                            "y": 190,
                                                            "h": 429,
                                                            "w": 429
                                                        },
                                                        {
                                                            "x": 613,
                                                            "y": 227,
                                                            "h": 518,
                                                            "w": 518
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1500,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1500,
                                                "width": 1200,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 226,
                                                        "w": 1200,
                                                        "h": 672
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1200
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1368
                                                    },
                                                    {
                                                        "x": 450,
                                                        "y": 0,
                                                        "w": 750,
                                                        "h": 1500
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1500
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1723475775641251840"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 106,
                                "favorited": false,
                                "full_text": "😳 Kylian Mbappé in May 2022: “In South America, football is not as advanced as in Europe, that’s why when you look at the last World Cups it’s always Europeans who win.”\n\n🗣️ Copa Liberadores 2023 champion Felipe Melo responded: \"Kylian Mbappé is an idiot.\n\nHe scored three goals https://t.co/B6H91DXz9z",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 3,
                                "reply_count": 12,
                                "retweet_count": 7,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1723475784696828269"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1711805742175428929",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1711805742175428929"
                                ],
                                "editable_until_msecs": "1696964867000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "12863",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                            "note_tweet": {
                                "is_expandable": true,
                                "note_tweet_results": {
                                    "result": {
                                        "id": "Tm90ZVR3ZWV0OjE3MTE4MDU3NDIwOTE1NTQ4MTY=",
                                        "text": "🚨 The Cristiano Ronaldo 🆚 Lionel Messi rivalry won't be ending anytime soon! 👇\n\nA report from @COPE states Ronaldo has told Al-Nassr he's keen to extend his contract with the club until 2027 🟡✍️\n\nMeaning he could:\n\n✅ Play at the 2026 World Cup.\n✅ Play until he's at least 41.\n✅ Play another three seasons at club level.\n\nHe's also said to have no plans to retire in the near future 💪❌",
                                        "entity_set": {
                                            "hashtags": [],
                                            "symbols": [],
                                            "urls": [],
                                            "user_mentions": [
                                                {
                                                    "id_str": "9706822",
                                                    "name": "COPE",
                                                    "screen_name": "COPE",
                                                    "indices": [
                                                        94,
                                                        99
                                                    ]
                                                }
                                            ]
                                        },
                                        "richtext": {
                                            "richtext_tags": []
                                        },
                                        "media": {
                                            "inline_media": []
                                        }
                                    }
                                }
                            },
                            "legacy": {
                                "bookmark_count": 1,
                                "bookmarked": false,
                                "created_at": "Tue Oct 10 18:07:47 +0000 2023",
                                "conversation_id_str": "1711805742175428929",
                                "display_text_range": [
                                    0,
                                    271
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/gcpu4i9wbv",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1711805742175428929/photo/1",
                                            "id_str": "1711805570603184131",
                                            "indices": [
                                                272,
                                                295
                                            ],
                                            "media_key": "3_1711805570603184131",
                                            "media_url_https": "https://pbs.twimg.com/media/F8GOGNBWcAMndcs.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/gCpu4i9wBV",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 858,
                                                            "y": 1319,
                                                            "h": 90,
                                                            "w": 90
                                                        },
                                                        {
                                                            "x": 449,
                                                            "y": 235,
                                                            "h": 479,
                                                            "w": 479
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 686,
                                                            "y": 1055,
                                                            "h": 72,
                                                            "w": 72
                                                        },
                                                        {
                                                            "x": 359,
                                                            "y": 188,
                                                            "h": 383,
                                                            "w": 383
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 388,
                                                            "y": 597,
                                                            "h": 40,
                                                            "w": 40
                                                        },
                                                        {
                                                            "x": 203,
                                                            "y": 106,
                                                            "h": 217,
                                                            "w": 217
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 858,
                                                            "y": 1319,
                                                            "h": 90,
                                                            "w": 90
                                                        },
                                                        {
                                                            "x": 449,
                                                            "y": 235,
                                                            "h": 479,
                                                            "w": 479
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1500,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1500,
                                                "width": 1200,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 226,
                                                        "w": 1200,
                                                        "h": 672
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1200
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1368
                                                    },
                                                    {
                                                        "x": 337,
                                                        "y": 0,
                                                        "w": 750,
                                                        "h": 1500
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1500
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1711805570603184131"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": [
                                        {
                                            "id_str": "9706822",
                                            "name": "COPE",
                                            "screen_name": "COPE",
                                            "indices": [
                                                94,
                                                99
                                            ]
                                        }
                                    ]
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/gCpu4i9wBV",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1711805742175428929/photo/1",
                                            "id_str": "1711805570603184131",
                                            "indices": [
                                                272,
                                                295
                                            ],
                                            "media_key": "3_1711805570603184131",
                                            "media_url_https": "https://pbs.twimg.com/media/F8GOGNBWcAMndcs.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/gCpu4i9wBV",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 858,
                                                            "y": 1319,
                                                            "h": 90,
                                                            "w": 90
                                                        },
                                                        {
                                                            "x": 449,
                                                            "y": 235,
                                                            "h": 479,
                                                            "w": 479
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 686,
                                                            "y": 1055,
                                                            "h": 72,
                                                            "w": 72
                                                        },
                                                        {
                                                            "x": 359,
                                                            "y": 188,
                                                            "h": 383,
                                                            "w": 383
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 388,
                                                            "y": 597,
                                                            "h": 40,
                                                            "w": 40
                                                        },
                                                        {
                                                            "x": 203,
                                                            "y": 106,
                                                            "h": 217,
                                                            "w": 217
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 858,
                                                            "y": 1319,
                                                            "h": 90,
                                                            "w": 90
                                                        },
                                                        {
                                                            "x": 449,
                                                            "y": 235,
                                                            "h": 479,
                                                            "w": 479
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1500,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1500,
                                                "width": 1200,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 226,
                                                        "w": 1200,
                                                        "h": 672
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1200
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1368
                                                    },
                                                    {
                                                        "x": 337,
                                                        "y": 0,
                                                        "w": 750,
                                                        "h": 1500
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1500
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1711805570603184131"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 87,
                                "favorited": false,
                                "full_text": "🚨 The Cristiano Ronaldo 🆚 Lionel Messi rivalry won't be ending anytime soon! 👇\n\nA report from @COPE states Ronaldo has told Al-Nassr he's keen to extend his contract with the club until 2027 🟡✍️\n\nMeaning he could:\n\n✅ Play at the 2026 World Cup.\n✅ Play until he's at least https://t.co/gCpu4i9wBV",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 1,
                                "reply_count": 3,
                                "retweet_count": 5,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1711805742175428929"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1705328494605943068",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1705328494605943068"
                                ],
                                "editable_until_msecs": "1695420571000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "5105",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                            "legacy": {
                                "bookmark_count": 0,
                                "bookmarked": false,
                                "created_at": "Fri Sep 22 21:09:31 +0000 2023",
                                "conversation_id_str": "1705328494605943068",
                                "display_text_range": [
                                    0,
                                    217
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/vfrupzgoay",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1705328494605943068/photo/1",
                                            "id_str": "1705328470870368256",
                                            "indices": [
                                                218,
                                                241
                                            ],
                                            "media_key": "3_1705328470870368256",
                                            "media_url_https": "https://pbs.twimg.com/media/F6qLNYOWoAAJSi-.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/VfruPzgOaY",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 467,
                                                            "y": 479,
                                                            "h": 58,
                                                            "w": 58
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 373,
                                                            "y": 383,
                                                            "h": 46,
                                                            "w": 46
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 211,
                                                            "y": 217,
                                                            "h": 26,
                                                            "w": 26
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 467,
                                                            "y": 479,
                                                            "h": 58,
                                                            "w": 58
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1500,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1500,
                                                "width": 1200,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 751,
                                                        "w": 1200,
                                                        "h": 672
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 300,
                                                        "w": 1200,
                                                        "h": 1200
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 132,
                                                        "w": 1200,
                                                        "h": 1368
                                                    },
                                                    {
                                                        "x": 187,
                                                        "y": 0,
                                                        "w": 750,
                                                        "h": 1500
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1500
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1705328470870368256"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.x.com/vfrupzgoay",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1705328494605943068/photo/1",
                                            "id_str": "1705328478868910081",
                                            "indices": [
                                                218,
                                                241
                                            ],
                                            "media_key": "3_1705328478868910081",
                                            "media_url_https": "https://pbs.twimg.com/media/F6qLN2BWsAErdNf.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/VfruPzgOaY",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 541,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 270,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 119,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 304,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1705328478868910081"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/VfruPzgOaY",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1705328494605943068/photo/1",
                                            "id_str": "1705328470870368256",
                                            "indices": [
                                                218,
                                                241
                                            ],
                                            "media_key": "3_1705328470870368256",
                                            "media_url_https": "https://pbs.twimg.com/media/F6qLNYOWoAAJSi-.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/VfruPzgOaY",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 467,
                                                            "y": 479,
                                                            "h": 58,
                                                            "w": 58
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 373,
                                                            "y": 383,
                                                            "h": 46,
                                                            "w": 46
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 211,
                                                            "y": 217,
                                                            "h": 26,
                                                            "w": 26
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 467,
                                                            "y": 479,
                                                            "h": 58,
                                                            "w": 58
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1500,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1500,
                                                "width": 1200,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 751,
                                                        "w": 1200,
                                                        "h": 672
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 300,
                                                        "w": 1200,
                                                        "h": 1200
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 132,
                                                        "w": 1200,
                                                        "h": 1368
                                                    },
                                                    {
                                                        "x": 187,
                                                        "y": 0,
                                                        "w": 750,
                                                        "h": 1500
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1500
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1705328470870368256"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.twitter.com/VfruPzgOaY",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1705328494605943068/photo/1",
                                            "id_str": "1705328478868910081",
                                            "indices": [
                                                218,
                                                241
                                            ],
                                            "media_key": "3_1705328478868910081",
                                            "media_url_https": "https://pbs.twimg.com/media/F6qLN2BWsAErdNf.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/VfruPzgOaY",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 541,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 270,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 119,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 304,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1705328478868910081"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 64,
                                "favorited": false,
                                "full_text": "Cristiano Ronaldo and Sadio Mané are the top scorers in the Saudi Pro League after 7 games: \n\n🇵🇹 Ronaldo: ⚽ 9 goals 🅰️ 4 assists\n\n🇸🇳 Mané: ⚽ 6 goals 🅰️ 1 assist\n\nThe Saudi Pro League wasn't ready for these two kings 👑 https://t.co/VfruPzgOaY",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 0,
                                "reply_count": 4,
                                "retweet_count": 8,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1705328494605943068"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1704376123272954352",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1704376123272954352"
                                ],
                                "editable_until_msecs": "1695193508000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "42856",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://twitter.com\" rel=\"nofollow\">TweetDeck Web App</a>",
                            "legacy": {
                                "bookmark_count": 14,
                                "bookmarked": false,
                                "created_at": "Wed Sep 20 06:05:08 +0000 2023",
                                "conversation_id_str": "1704376123272954352",
                                "display_text_range": [
                                    0,
                                    186
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/lbhrtmm1yh",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1704376123272954352/photo/1",
                                            "id_str": "1704375732061782016",
                                            "indices": [
                                                187,
                                                210
                                            ],
                                            "media_key": "3_1704375732061782016",
                                            "media_url_https": "https://pbs.twimg.com/media/F6cosrlWwAA8kPZ.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/LbhRtMm1yH",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 280,
                                                            "y": 172,
                                                            "h": 345,
                                                            "w": 345
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 248,
                                                            "y": 152,
                                                            "h": 306,
                                                            "w": 306
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 141,
                                                            "y": 86,
                                                            "h": 173,
                                                            "w": 173
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 280,
                                                            "y": 172,
                                                            "h": 345,
                                                            "w": 345
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 69,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 101,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1704375732061782016"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/LbhRtMm1yH",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1704376123272954352/photo/1",
                                            "id_str": "1704375732061782016",
                                            "indices": [
                                                187,
                                                210
                                            ],
                                            "media_key": "3_1704375732061782016",
                                            "media_url_https": "https://pbs.twimg.com/media/F6cosrlWwAA8kPZ.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/LbhRtMm1yH",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 280,
                                                            "y": 172,
                                                            "h": 345,
                                                            "w": 345
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 248,
                                                            "y": 152,
                                                            "h": 306,
                                                            "w": 306
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 141,
                                                            "y": 86,
                                                            "h": 173,
                                                            "w": 173
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 280,
                                                            "y": 172,
                                                            "h": 345,
                                                            "w": 345
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 69,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 101,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1704375732061782016"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 1012,
                                "favorited": false,
                                "full_text": "The stars aligned for Ivan Provedel and the number 94 🤯\n\n👉 Born in 1994 \n👉 Height of 1.94 \n👉 Wears the number 94 \n👉 Scored against Atlético in the 94th minute \n\nMIND OFFICIALLY BLOWN 🤯🇮🇹 https://t.co/LbhRtMm1yH",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 9,
                                "reply_count": 9,
                                "retweet_count": 86,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1704376123272954352"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1665361513295785986",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjo3OTkzNjk5Njk3MjUyMjcwMDg=",
                                        "rest_id": "799369969725227008",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Circle",
                                        "legacy": {
                                            "created_at": "Thu Nov 17 21:53:47 +0000 2016",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "The must-have app for football fans: Live scores, highlights, news and much more. Join the club 👉 @ofc_the_club\n\nFor support: @OneFootballCare ⚽️📲",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "onefootball.link/46igysv",
                                                            "expanded_url": "https://onefootball.link/46igysv",
                                                            "url": "https://t.co/RIUfSIx7Ud",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 623,
                                            "followers_count": 176949,
                                            "friends_count": 576,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 709,
                                            "location": "Download the app 👉",
                                            "media_count": 15515,
                                            "name": "OneFootball",
                                            "normal_followers_count": 176949,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/799369969725227008/1719965589",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1425737051899564040/KeRAoaXO_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "OneFootball",
                                            "statuses_count": 20685,
                                            "translator_type": "none",
                                            "url": "https://t.co/RIUfSIx7Ud",
                                            "verified": false,
                                            "withheld_in_countries": []
                                        },
                                        "professional": {
                                            "rest_id": "1772986690761568583",
                                            "professional_type": "Business",
                                            "category": [
                                                {
                                                    "id": 1009,
                                                    "name": "Community",
                                                    "icon_name": "IconBriefcaseStroke"
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1665361513295785986"
                                ],
                                "editable_until_msecs": "1685889900000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "14361",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                            "legacy": {
                                "bookmark_count": 2,
                                "bookmarked": false,
                                "created_at": "Sun Jun 04 14:15:00 +0000 2023",
                                "conversation_id_str": "1665361513295785986",
                                "display_text_range": [
                                    0,
                                    218
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/vdeurnckgu",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1665361513295785986/photo/1",
                                            "id_str": "1665353050632978434",
                                            "indices": [
                                                219,
                                                242
                                            ],
                                            "media_key": "3_1665353050632978434",
                                            "media_url_https": "https://pbs.twimg.com/media/FxyFxrCXgAIXmqm.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/VdeURnCkgU",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 326,
                                                            "y": 224,
                                                            "h": 172,
                                                            "w": 172
                                                        },
                                                        {
                                                            "x": 729,
                                                            "y": 840,
                                                            "h": 181,
                                                            "w": 181
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 260,
                                                            "y": 179,
                                                            "h": 137,
                                                            "w": 137
                                                        },
                                                        {
                                                            "x": 583,
                                                            "y": 672,
                                                            "h": 144,
                                                            "w": 144
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 147,
                                                            "y": 101,
                                                            "h": 77,
                                                            "w": 77
                                                        },
                                                        {
                                                            "x": 330,
                                                            "y": 380,
                                                            "h": 82,
                                                            "w": 82
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 326,
                                                            "y": 224,
                                                            "h": 172,
                                                            "w": 172
                                                        },
                                                        {
                                                            "x": 729,
                                                            "y": 840,
                                                            "h": 181,
                                                            "w": 181
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1500,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1500,
                                                "width": 1200,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 826,
                                                        "w": 1200,
                                                        "h": 672
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 300,
                                                        "w": 1200,
                                                        "h": 1200
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 132,
                                                        "w": 1200,
                                                        "h": 1368
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 750,
                                                        "h": 1500
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1500
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1665353050632978434"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/VdeURnCkgU",
                                            "expanded_url": "https://twitter.com/OneFootball/status/1665361513295785986/photo/1",
                                            "id_str": "1665353050632978434",
                                            "indices": [
                                                219,
                                                242
                                            ],
                                            "media_key": "3_1665353050632978434",
                                            "media_url_https": "https://pbs.twimg.com/media/FxyFxrCXgAIXmqm.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/VdeURnCkgU",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 326,
                                                            "y": 224,
                                                            "h": 172,
                                                            "w": 172
                                                        },
                                                        {
                                                            "x": 729,
                                                            "y": 840,
                                                            "h": 181,
                                                            "w": 181
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 260,
                                                            "y": 179,
                                                            "h": 137,
                                                            "w": 137
                                                        },
                                                        {
                                                            "x": 583,
                                                            "y": 672,
                                                            "h": 144,
                                                            "w": 144
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 147,
                                                            "y": 101,
                                                            "h": 77,
                                                            "w": 77
                                                        },
                                                        {
                                                            "x": 330,
                                                            "y": 380,
                                                            "h": 82,
                                                            "w": 82
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 326,
                                                            "y": 224,
                                                            "h": 172,
                                                            "w": 172
                                                        },
                                                        {
                                                            "x": 729,
                                                            "y": 840,
                                                            "h": 181,
                                                            "w": 181
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1500,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1500,
                                                "width": 1200,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 826,
                                                        "w": 1200,
                                                        "h": 672
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 300,
                                                        "w": 1200,
                                                        "h": 1200
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 132,
                                                        "w": 1200,
                                                        "h": 1368
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 750,
                                                        "h": 1500
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1200,
                                                        "h": 1500
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1665353050632978434"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 319,
                                "favorited": false,
                                "full_text": "2009: Both signed in the same summer 🤝\n\nMost goals in Real Madrid history:\n1. Cristiano Ronaldo\n2. Karim Benzema\n\nMost assists in Real Madrid history:\n\n1. Karim Benzema\n2. Cristiano Ronaldo\n\nTruly legends of the game 🔥 https://t.co/VdeURnCkgU",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 2,
                                "reply_count": 1,
                                "retweet_count": 34,
                                "retweeted": false,
                                "user_id_str": "799369969725227008",
                                "id_str": "1665361513295785986"
                            }
                        }
                    }
                }
            }
        ]
    },
    realmadrid: {
        usernameData: {
            "data": {
                "user": {
                    "result": {
                        "__typename": "User",
                        "id": "VXNlcjoxNDg3MjIzNw==",
                        "rest_id": "14872237",
                        "affiliates_highlighted_label": {},
                        "is_blue_verified": true,
                        "profile_image_shape": "Square",
                        "legacy": {
                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                            "default_profile": false,
                            "default_profile_image": false,
                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                            "entities": {
                                "description": {
                                    "urls": []
                                },
                                "url": {
                                    "urls": [
                                        {
                                            "display_url": "bit.ly/RealMadridRMPl…",
                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "indices": [
                                                0,
                                                23
                                            ]
                                        }
                                    ]
                                }
                            },
                            "fast_followers_count": 0,
                            "favourites_count": 956,
                            "followers_count": 51200720,
                            "friends_count": 64,
                            "has_custom_timelines": true,
                            "is_translator": false,
                            "listed_count": 44853,
                            "location": "Madrid, Spain",
                            "media_count": 47354,
                            "name": "Real Madrid C.F.",
                            "normal_followers_count": 51200720,
                            "pinned_tweet_ids_str": [],
                            "possibly_sensitive": false,
                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1734558292",
                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                            "profile_interstitial_type": "",
                            "screen_name": "realmadrid",
                            "statuses_count": 98515,
                            "translator_type": "regular",
                            "url": "https://t.co/iXjSgoOMZ8",
                            "verified": false,
                            "verified_type": "Business",
                            "withheld_in_countries": []
                        },
                        "legacy_extended_profile": {},
                        "is_profile_translatable": false,
                        "has_hidden_likes_on_profile": true,
                        "has_hidden_subscriptions_on_profile": false,
                        "verification_info": {
                            "is_identity_verified": false,
                            "reason": {
                                "description": {
                                    "text": "This account is verified because it's an official organization on X. Learn more",
                                    "entities": [
                                        {
                                            "from_index": 69,
                                            "to_index": 79,
                                            "ref": {
                                                "url": "https://help.twitter.com/en/rules-and-policies/profile-labels",
                                                "url_type": "ExternalUrl"
                                            }
                                        }
                                    ]
                                },
                                "verified_since_msec": "1276643267148"
                            }
                        },
                        "highlights_info": {
                            "can_highlight_tweets": true,
                            "highlighted_tweets": "4"
                        },
                        "user_seed_tweet_count": 0,
                        "business_account": {
                            "affiliates_count": 23
                        },
                        "creator_subscriptions_count": 0
                    }
                }
            }
        },
        userTweetsData: [
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1811145842042003648",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200717,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200717,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1811145842042003648"
                                ],
                                "editable_until_msecs": "1720649392000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "369037",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://twitter.com\" rel=\"nofollow\">TweetDeck Web App</a>",
                            "legacy": {
                                "bookmark_count": 66,
                                "bookmarked": false,
                                "created_at": "Wed Jul 10 21:09:52 +0000 2024",
                                "conversation_id_str": "1811145842042003648",
                                "display_text_range": [
                                    0,
                                    76
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                33,
                                                42
                                            ],
                                            "text": "EURO2024"
                                        }
                                    ],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/hmtsymc92j",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1811145842042003648/photo/1",
                                            "id_str": "1811145668490317824",
                                            "indices": [
                                                77,
                                                100
                                            ],
                                            "media_key": "3_1811145668490317824",
                                            "media_url_https": "https://pbs.twimg.com/media/GSJ7Y77aUAA2bK8.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/hMtSYmC92J",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 330,
                                                            "y": 114,
                                                            "h": 142,
                                                            "w": 142
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 293,
                                                            "y": 101,
                                                            "h": 126,
                                                            "w": 126
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 166,
                                                            "y": 57,
                                                            "h": 71,
                                                            "w": 71
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 330,
                                                            "y": 114,
                                                            "h": 142,
                                                            "w": 142
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 101,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1811145668490317824"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": [
                                        {
                                            "id_str": "1073583235228229633",
                                            "name": "Jude Bellingham",
                                            "screen_name": "BellinghamJude",
                                            "indices": [
                                                61,
                                                76
                                            ]
                                        }
                                    ]
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/hMtSYmC92J",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1811145842042003648/photo/1",
                                            "id_str": "1811145668490317824",
                                            "indices": [
                                                77,
                                                100
                                            ],
                                            "media_key": "3_1811145668490317824",
                                            "media_url_https": "https://pbs.twimg.com/media/GSJ7Y77aUAA2bK8.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/hMtSYmC92J",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 330,
                                                            "y": 114,
                                                            "h": 142,
                                                            "w": 142
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 293,
                                                            "y": 101,
                                                            "h": 126,
                                                            "w": 126
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 166,
                                                            "y": 57,
                                                            "h": 71,
                                                            "w": 71
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 330,
                                                            "y": 114,
                                                            "h": 142,
                                                            "w": 142
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 101,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1811145668490317824"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 20148,
                                "favorited": false,
                                "full_text": "➡️ ¡Inglaterra, a la final de la #EURO2024!\n🇳🇱 1-2 🏴󠁧󠁢󠁥󠁮󠁧󠁿\n👉 @BellinghamJude https://t.co/hMtSYmC92J",
                                "is_quote_status": false,
                                "lang": "es",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 47,
                                "reply_count": 276,
                                "retweet_count": 1095,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1811145842042003648"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1796859244492538330",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200723,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200723,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1796859244492538330"
                                ],
                                "editable_until_msecs": "1717243202000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": true,
                            "views": {
                                "count": "1107660",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://twitter.com\" rel=\"nofollow\">TweetDeck Web App</a>",
                            "legacy": {
                                "bookmark_count": 263,
                                "bookmarked": false,
                                "created_at": "Sat Jun 01 11:00:02 +0000 2024",
                                "conversation_id_str": "1796859244492538330",
                                "display_text_range": [
                                    0,
                                    69
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                48,
                                                57
                                            ],
                                            "text": "APorLa15"
                                        },
                                        {
                                            "indices": [
                                                60,
                                                69
                                            ],
                                            "text": "UCLfinal"
                                        }
                                    ],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/tlmnmeffko",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1796859244492538330/photo/1",
                                            "id_str": "1796822962709913600",
                                            "indices": [
                                                70,
                                                93
                                            ],
                                            "media_key": "3_1796822962709913600",
                                            "media_url_https": "https://pbs.twimg.com/media/GO-Y9vCW4AAxXzj.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/TlMNmefFko",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 2048,
                                                    "w": 1639,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 4096,
                                                "width": 3277,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 3277,
                                                        "h": 1835
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 3277,
                                                        "h": 3277
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 3277,
                                                        "h": 3736
                                                    },
                                                    {
                                                        "x": 716,
                                                        "y": 0,
                                                        "w": 2048,
                                                        "h": 4096
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 3277,
                                                        "h": 4096
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1796822962709913600"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.x.com/tlmnmeffko",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1796859244492538330/photo/1",
                                            "id_str": "1796822962730864640",
                                            "indices": [
                                                70,
                                                93
                                            ],
                                            "media_key": "3_1796822962730864640",
                                            "media_url_https": "https://pbs.twimg.com/media/GO-Y9vHWkAAzruG.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/TlMNmefFko",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 2048,
                                                    "w": 1638,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 4096,
                                                "width": 3276,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 413,
                                                        "w": 3276,
                                                        "h": 1835
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 3276,
                                                        "h": 3276
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 3276,
                                                        "h": 3735
                                                    },
                                                    {
                                                        "x": 511,
                                                        "y": 0,
                                                        "w": 2048,
                                                        "h": 4096
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 3276,
                                                        "h": 4096
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1796822962730864640"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/TlMNmefFko",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1796859244492538330/photo/1",
                                            "id_str": "1796822962709913600",
                                            "indices": [
                                                70,
                                                93
                                            ],
                                            "media_key": "3_1796822962709913600",
                                            "media_url_https": "https://pbs.twimg.com/media/GO-Y9vCW4AAxXzj.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/TlMNmefFko",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 2048,
                                                    "w": 1639,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 4096,
                                                "width": 3277,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 3277,
                                                        "h": 1835
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 3277,
                                                        "h": 3277
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 3277,
                                                        "h": 3736
                                                    },
                                                    {
                                                        "x": 716,
                                                        "y": 0,
                                                        "w": 2048,
                                                        "h": 4096
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 3277,
                                                        "h": 4096
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1796822962709913600"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.twitter.com/TlMNmefFko",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1796859244492538330/photo/1",
                                            "id_str": "1796822962730864640",
                                            "indices": [
                                                70,
                                                93
                                            ],
                                            "media_key": "3_1796822962730864640",
                                            "media_url_https": "https://pbs.twimg.com/media/GO-Y9vHWkAAzruG.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/TlMNmefFko",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 2048,
                                                    "w": 1638,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 4096,
                                                "width": 3276,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 413,
                                                        "w": 3276,
                                                        "h": 1835
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 3276,
                                                        "h": 3276
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 3276,
                                                        "h": 3735
                                                    },
                                                    {
                                                        "x": 511,
                                                        "y": 0,
                                                        "w": 2048,
                                                        "h": 4096
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 3276,
                                                        "h": 4096
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1796822962730864640"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 29783,
                                "favorited": false,
                                "full_text": "👕✨ ¡Una camiseta especial para un día especial!\n#APorLa15 | #UCLfinal https://t.co/TlMNmefFko",
                                "is_quote_status": false,
                                "lang": "es",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 257,
                                "reply_count": 213,
                                "retweet_count": 3815,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1796859244492538330"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1795107698255741395",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200723,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200723,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "card": {
                                "rest_id": "card://1795089173289828354",
                                "legacy": {
                                    "binding_values": [
                                        {
                                            "key": "unified_card",
                                            "value": {
                                                "string_value": "{\"type\":\"image_website\",\"component_objects\":{\"details_1\":{\"type\":\"details\",\"data\":{\"title\":{\"content\":\"M\\u00E1s informaci\\u00F3n\",\"is_rtl\":false},\"subtitle\":{\"content\":\"realmadrid.com\",\"is_rtl\":false},\"destination\":\"browser_1\"}},\"media_1\":{\"type\":\"media\",\"data\":{\"id\":\"3_1795088038327898113\",\"destination\":\"browser_1\"}}},\"destination_objects\":{\"browser_1\":{\"type\":\"browser\",\"data\":{\"url_data\":{\"url\":\"https://www.realmadrid.com/es-ES/noticias/futbol/primer-equipo/actualidad/kroos-27-05-2024\",\"vanity\":\"realmadrid.com\"}}}},\"components\":[\"media_1\",\"details_1\"],\"media_entities\":{\"3_1795088038327898113\":{\"id\":1795088038327898113,\"id_str\":\"1795088038327898113\",\"indices\":[0,0],\"media_url\":\"\",\"media_url_https\":\"https://pbs.twimg.com/media/GOlvD2EWUAEDH39.jpg\",\"url\":\"\",\"display_url\":\"\",\"expanded_url\":\"\",\"type\":\"photo\",\"original_info\":{\"width\":800,\"height\":800,\"focus_rects\":[{\"x\":0,\"y\":156,\"h\":448,\"w\":800},{\"x\":0,\"y\":0,\"h\":800,\"w\":800},{\"x\":0,\"y\":0,\"h\":800,\"w\":702},{\"x\":20,\"y\":0,\"h\":800,\"w\":400},{\"x\":0,\"y\":0,\"h\":800,\"w\":800}]},\"sizes\":{\"medium\":{\"w\":800,\"h\":800,\"resize\":\"fit\"},\"thumb\":{\"w\":150,\"h\":150,\"resize\":\"crop\"},\"large\":{\"w\":800,\"h\":800,\"resize\":\"fit\"},\"small\":{\"w\":680,\"h\":680,\"resize\":\"fit\"}},\"source_user_id\":14872237,\"source_user_id_str\":\"14872237\",\"media_key\":\"3_1795088038327898113\",\"ext\":{\"mediaColor\":{\"r\":{\"ok\":{\"palette\":[{\"rgb\":{\"red\":205,\"green\":211,\"blue\":211},\"percentage\":41.26},{\"rgb\":{\"red\":35,\"green\":38,\"blue\":43},\"percentage\":30.66},{\"rgb\":{\"red\":181,\"green\":137,\"blue\":119},\"percentage\":10.24},{\"rgb\":{\"red\":170,\"green\":188,\"blue\":132},\"percentage\":6.81},{\"rgb\":{\"red\":110,\"green\":78,\"blue\":49},\"percentage\":3.06}]}},\"ttl\":-1}}}}}",
                                                "type": "STRING"
                                            }
                                        },
                                        {
                                            "key": "card_url",
                                            "value": {
                                                "scribe_key": "card_url",
                                                "string_value": "https://twitter.com",
                                                "type": "STRING"
                                            }
                                        }
                                    ],
                                    "card_platform": {
                                        "platform": {
                                            "audience": {
                                                "name": "production"
                                            },
                                            "device": {
                                                "name": "Swift",
                                                "version": "12"
                                            }
                                        }
                                    },
                                    "name": "unified_card",
                                    "url": "card://1795089173289828354",
                                    "user_refs_results": []
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1795107698255741395"
                                ],
                                "editable_until_msecs": "1716825601000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": true,
                            "views": {
                                "count": "203990",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://twitter.com\" rel=\"nofollow\">Twitter for Advertisers</a>",
                            "legacy": {
                                "bookmark_count": 61,
                                "bookmarked": false,
                                "created_at": "Mon May 27 15:00:01 +0000 2024",
                                "conversation_id_str": "1795107698255741395",
                                "display_text_range": [
                                    0,
                                    105
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                89,
                                                93
                                            ],
                                            "text": "UCL"
                                        },
                                        {
                                            "indices": [
                                                96,
                                                105
                                            ],
                                            "text": "APorLa15"
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": [
                                        {
                                            "id_str": "330446733",
                                            "name": "Toni Kroos",
                                            "screen_name": "ToniKroos",
                                            "indices": [
                                                3,
                                                13
                                            ]
                                        }
                                    ]
                                },
                                "favorite_count": 7379,
                                "favorited": false,
                                "full_text": "🎙️ @ToniKroos: \"Va a ser mi último esfuerzo para el Real Madrid y solo pienso en ganar\".\n#UCL | #APorLa15",
                                "is_quote_status": false,
                                "lang": "es",
                                "quote_count": 18,
                                "reply_count": 59,
                                "retweet_count": 575,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1795107698255741395"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1794760406168416476",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200720,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200720,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1794760406168416476"
                                ],
                                "editable_until_msecs": "1716742800000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "167843",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://studio.twitter.com\" rel=\"nofollow\">Twitter Media Studio</a>",
                            "legacy": {
                                "bookmark_count": 129,
                                "bookmarked": false,
                                "created_at": "Sun May 26 16:00:00 +0000 2024",
                                "conversation_id_str": "1794760406168416476",
                                "display_text_range": [
                                    0,
                                    103
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                21,
                                                34
                                            ],
                                            "text": "GraciasKroos"
                                        },
                                        {
                                            "indices": [
                                                47,
                                                54
                                            ],
                                            "text": "RMPLAY"
                                        },
                                        {
                                            "indices": [
                                                81,
                                                91
                                            ],
                                            "text": "FlyBetter"
                                        }
                                    ],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/8usfi703zi",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1794760406168416476/video/1",
                                            "id_str": "1794747675348242432",
                                            "indices": [
                                                104,
                                                127
                                            ],
                                            "media_key": "13_1794747675348242432",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1794747675348242432/img/gguPfE17NxSSm6wZ.jpg",
                                            "type": "video",
                                            "url": "https://t.co/8USFi703zI",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    1,
                                                    1
                                                ],
                                                "duration_millis": 30080,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1794747675348242432/pl/sdw-Ira4MDoCstjg.m3u8?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 432000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1794747675348242432/vid/avc1/320x320/2t3IjLhnJHJlIELS.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1794747675348242432/vid/avc1/540x540/wrqfLaaaBD2iV5Eg.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 1280000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1794747675348242432/vid/avc1/720x720/6mIJg8RAwvpJEmGj.mp4?tag=14"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1794747675348242432"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [
                                        {
                                            "display_url": "bit.ly/DIARIES_DankeK…",
                                            "expanded_url": "http://bit.ly/DIARIES_DankeKroos",
                                            "url": "https://t.co/gn98lFJ9kp",
                                            "indices": [
                                                57,
                                                80
                                            ]
                                        }
                                    ],
                                    "user_mentions": [
                                        {
                                            "id_str": "821045162",
                                            "name": "Emirates",
                                            "screen_name": "emirates",
                                            "indices": [
                                                94,
                                                103
                                            ]
                                        }
                                    ]
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/8USFi703zI",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1794760406168416476/video/1",
                                            "id_str": "1794747675348242432",
                                            "indices": [
                                                104,
                                                127
                                            ],
                                            "media_key": "13_1794747675348242432",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1794747675348242432/img/gguPfE17NxSSm6wZ.jpg",
                                            "type": "video",
                                            "url": "https://t.co/8USFi703zI",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    1,
                                                    1
                                                ],
                                                "duration_millis": 30080,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1794747675348242432/pl/sdw-Ira4MDoCstjg.m3u8?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 432000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1794747675348242432/vid/avc1/320x320/2t3IjLhnJHJlIELS.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1794747675348242432/vid/avc1/540x540/wrqfLaaaBD2iV5Eg.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 1280000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1794747675348242432/vid/avc1/720x720/6mIJg8RAwvpJEmGj.mp4?tag=14"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1794747675348242432"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 4663,
                                "favorited": false,
                                "full_text": "🆕 LALIGA DIARIES 🆕\n🤍 #GraciasKroos 🤍\nDIARIES 👉 #RMPLAY\n🔗 https://t.co/gn98lFJ9kp\n#FlyBetter | @Emirates https://t.co/8USFi703zI",
                                "is_quote_status": false,
                                "lang": "ca",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 17,
                                "reply_count": 68,
                                "retweet_count": 539,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1794760406168416476"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1794429268107178079",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200720,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200720,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1794429268107178079"
                                ],
                                "editable_until_msecs": "1716663851000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": true,
                            "views": {
                                "count": "152903",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://studio.twitter.com\" rel=\"nofollow\">Twitter Media Studio</a>",
                            "legacy": {
                                "bookmark_count": 43,
                                "bookmarked": false,
                                "created_at": "Sat May 25 18:04:11 +0000 2024",
                                "conversation_id_str": "1794429268107178079",
                                "display_text_range": [
                                    0,
                                    64
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                44,
                                                64
                                            ],
                                            "text": "RealMadridRealBetis"
                                        }
                                    ],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/hvtabxdxoo",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1794429268107178079/video/1",
                                            "id_str": "1794429036212391936",
                                            "indices": [
                                                65,
                                                88
                                            ],
                                            "media_key": "13_1794429036212391936",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1794429036212391936/img/iVAxzkz0sHw-3RFC.jpg",
                                            "type": "video",
                                            "url": "https://t.co/HvtabXDxoO",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    1,
                                                    1
                                                ],
                                                "duration_millis": 23800,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1794429036212391936/pl/asSNTJ0pEGCXF7ZS.m3u8?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 432000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1794429036212391936/vid/avc1/320x320/qq-_H4ULllkH4WLX.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1794429036212391936/vid/avc1/540x540/PKZQvVy0pzNEe9xx.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 1280000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1794429036212391936/vid/avc1/720x720/2AhuANmbFlhIEK_B.mp4?tag=14"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1794429036212391936"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/HvtabXDxoO",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1794429268107178079/video/1",
                                            "id_str": "1794429036212391936",
                                            "indices": [
                                                65,
                                                88
                                            ],
                                            "media_key": "13_1794429036212391936",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1794429036212391936/img/iVAxzkz0sHw-3RFC.jpg",
                                            "type": "video",
                                            "url": "https://t.co/HvtabXDxoO",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    1,
                                                    1
                                                ],
                                                "duration_millis": 23800,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1794429036212391936/pl/asSNTJ0pEGCXF7ZS.m3u8?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 432000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1794429036212391936/vid/avc1/320x320/qq-_H4ULllkH4WLX.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1794429036212391936/vid/avc1/540x540/PKZQvVy0pzNEe9xx.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 1280000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1794429036212391936/vid/avc1/720x720/2AhuANmbFlhIEK_B.mp4?tag=14"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1794429036212391936"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 3139,
                                "favorited": false,
                                "full_text": "🏠 ¡Listos para el último partido de LaLiga!\n#RealMadridRealBetis https://t.co/HvtabXDxoO",
                                "is_quote_status": false,
                                "lang": "es",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 15,
                                "reply_count": 65,
                                "retweet_count": 257,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1794429268107178079"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1789629299919622236",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200723,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200723,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1789629299919622236"
                                ],
                                "editable_until_msecs": "1715519449000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": true,
                            "views": {
                                "count": "731822",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://studio.twitter.com\" rel=\"nofollow\">Twitter Media Studio</a>",
                            "legacy": {
                                "bookmark_count": 522,
                                "bookmarked": false,
                                "created_at": "Sun May 12 12:10:49 +0000 2024",
                                "conversation_id_str": "1789629299919622236",
                                "display_text_range": [
                                    0,
                                    71
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                49,
                                                61
                                            ],
                                            "text": "Madridistas"
                                        },
                                        {
                                            "indices": [
                                                63,
                                                71
                                            ],
                                            "text": "36Ligas"
                                        }
                                    ],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/tc0ci9sysc",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1789629299919622236/video/1",
                                            "id_str": "1789629158202441728",
                                            "indices": [
                                                72,
                                                95
                                            ],
                                            "media_key": "13_1789629158202441728",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1789629158202441728/img/n8D3blsPerkoCnh3.jpg",
                                            "type": "video",
                                            "url": "https://t.co/tc0CI9sysc",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1920,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 675,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 383,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1920,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    16,
                                                    9
                                                ],
                                                "duration_millis": 24360,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1789629158202441728/pl/Dwd6KB-fIyCDJRLF.m3u8?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 288000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1789629158202441728/vid/avc1/480x270/XaKIyOQSWr_mknwE.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1789629158202441728/vid/avc1/640x360/yKYMLbJj5mEXMvxm.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 2176000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1789629158202441728/vid/avc1/1280x720/AUsQWkWKqamML_Yz.mp4?tag=14"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1789629158202441728"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": [
                                        {
                                            "id_str": "444838837",
                                            "name": "Carlo Ancelotti",
                                            "screen_name": "MrAncelotti",
                                            "indices": [
                                                17,
                                                29
                                            ]
                                        }
                                    ]
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/tc0CI9sysc",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1789629299919622236/video/1",
                                            "id_str": "1789629158202441728",
                                            "indices": [
                                                72,
                                                95
                                            ],
                                            "media_key": "13_1789629158202441728",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1789629158202441728/img/n8D3blsPerkoCnh3.jpg",
                                            "type": "video",
                                            "url": "https://t.co/tc0CI9sysc",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1920,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 675,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 383,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1920,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    16,
                                                    9
                                                ],
                                                "duration_millis": 24360,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1789629158202441728/pl/Dwd6KB-fIyCDJRLF.m3u8?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 288000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1789629158202441728/vid/avc1/480x270/XaKIyOQSWr_mknwE.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1789629158202441728/vid/avc1/640x360/yKYMLbJj5mEXMvxm.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 2176000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1789629158202441728/vid/avc1/1280x720/AUsQWkWKqamML_Yz.mp4?tag=14"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1789629158202441728"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 20795,
                                "favorited": false,
                                "full_text": "🤣 🕺 ¡El sueño de @MrAncelotti es el de todos los #Madridistas!\n#36Ligas https://t.co/tc0CI9sysc",
                                "is_quote_status": false,
                                "lang": "es",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 342,
                                "reply_count": 201,
                                "retweet_count": 2955,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1789629299919622236"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1789342363158008246",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200719,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200719,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1789342363158008246"
                                ],
                                "editable_until_msecs": "1715451038000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "308001",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://twitter.com\" rel=\"nofollow\">TweetDeck Web App</a>",
                            "legacy": {
                                "bookmark_count": 15,
                                "bookmarked": false,
                                "created_at": "Sat May 11 17:10:38 +0000 2024",
                                "conversation_id_str": "1789342363158008246",
                                "display_text_range": [
                                    0,
                                    76
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                51,
                                                69
                                            ],
                                            "text": "GranadaRealMadrid"
                                        },
                                        {
                                            "indices": [
                                                71,
                                                76
                                            ],
                                            "text": "FC24"
                                        }
                                    ],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/8sqdn8ytrw",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1789342363158008246/video/1",
                                            "id_str": "1789342135889653760",
                                            "indices": [
                                                77,
                                                100
                                            ],
                                            "media_key": "7_1789342135889653760",
                                            "media_url_https": "https://pbs.twimg.com/ext_tw_video_thumb/1789342135889653760/pu/img/aYCVlRkUXlYUbnxG.jpg",
                                            "type": "video",
                                            "url": "https://t.co/8SQDN8YTRW",
                                            "additional_media_info": {
                                                "monetizable": false
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    1,
                                                    1
                                                ],
                                                "duration_millis": 7500,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/ext_tw_video/1789342135889653760/pu/pl/0tGm350qoqQhCnBU.m3u8?tag=12"
                                                    },
                                                    {
                                                        "bitrate": 432000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/ext_tw_video/1789342135889653760/pu/vid/avc1/320x320/QO-sXns9bgTYOiQ4.mp4?tag=12"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/ext_tw_video/1789342135889653760/pu/vid/avc1/540x540/78ZNCxqgdcmvb-jk.mp4?tag=12"
                                                    },
                                                    {
                                                        "bitrate": 1280000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/ext_tw_video/1789342135889653760/pu/vid/avc1/720x720/NK0xU8K4g_58ZTkm.mp4?tag=12"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "7_1789342135889653760"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": [
                                        {
                                            "id_str": "2265731470",
                                            "name": "Fran García",
                                            "screen_name": "Frangarcia_11",
                                            "indices": [
                                                33,
                                                47
                                            ]
                                        }
                                    ]
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/8SQDN8YTRW",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1789342363158008246/video/1",
                                            "id_str": "1789342135889653760",
                                            "indices": [
                                                77,
                                                100
                                            ],
                                            "media_key": "7_1789342135889653760",
                                            "media_url_https": "https://pbs.twimg.com/ext_tw_video_thumb/1789342135889653760/pu/img/aYCVlRkUXlYUbnxG.jpg",
                                            "type": "video",
                                            "url": "https://t.co/8SQDN8YTRW",
                                            "additional_media_info": {
                                                "monetizable": false
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    1,
                                                    1
                                                ],
                                                "duration_millis": 7500,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/ext_tw_video/1789342135889653760/pu/pl/0tGm350qoqQhCnBU.m3u8?tag=12"
                                                    },
                                                    {
                                                        "bitrate": 432000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/ext_tw_video/1789342135889653760/pu/vid/avc1/320x320/QO-sXns9bgTYOiQ4.mp4?tag=12"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/ext_tw_video/1789342135889653760/pu/vid/avc1/540x540/78ZNCxqgdcmvb-jk.mp4?tag=12"
                                                    },
                                                    {
                                                        "bitrate": 1280000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/ext_tw_video/1789342135889653760/pu/vid/avc1/720x720/NK0xU8K4g_58ZTkm.mp4?tag=12"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "7_1789342135889653760"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 6601,
                                "favorited": false,
                                "full_text": "⚽ 38' | 0-1 | ¡¡¡GOOOOOOOOOOL de @Frangarcia_11!!!\n#GranadaRealMadrid| #FC24 https://t.co/8SQDN8YTRW",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 40,
                                "reply_count": 124,
                                "retweet_count": 911,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1789342363158008246"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1787527749797912626",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200719,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200719,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "card": {
                                "rest_id": "card://1787497672754003968",
                                "legacy": {
                                    "binding_values": [
                                        {
                                            "key": "unified_card",
                                            "value": {
                                                "string_value": "{\"type\":\"video_website\",\"component_objects\":{\"details_1\":{\"type\":\"details\",\"data\":{\"title\":{\"content\":\"\\u00A1EL V\\u00CDDEO COMPLETO, GRATIS!\",\"is_rtl\":false},\"subtitle\":{\"content\":\"realmadrid.com\",\"is_rtl\":false},\"destination\":\"browser_with_docked_media_1\"}},\"media_1\":{\"type\":\"media\",\"data\":{\"id\":\"13_1787497086348296192\",\"destination\":\"browser_with_docked_media_1\"}}},\"destination_objects\":{\"browser_with_docked_media_1\":{\"type\":\"browser_with_docked_media\",\"data\":{\"url_data\":{\"url\":\"https://play.realmadrid.com/playlist/13447?showInterstitial=false\",\"vanity\":\"realmadrid.com\"},\"media_id\":\"13_1787497086348296192\"}}},\"components\":[\"media_1\",\"details_1\"],\"media_entities\":{\"13_1787497086348296192\":{\"id\":1787497086348296192,\"id_str\":\"1787497086348296192\",\"indices\":[0,0],\"media_url\":\"\",\"media_url_https\":\"https://pbs.twimg.com/amplify_video_thumb/1787497086348296192/img/_oecaNlGXWljA-eC.jpg\",\"url\":\"\",\"display_url\":\"\",\"expanded_url\":\"\",\"type\":\"video\",\"original_info\":{\"width\":1080,\"height\":1080},\"sizes\":{\"medium\":{\"w\":1080,\"h\":1080,\"resize\":\"fit\"},\"large\":{\"w\":1080,\"h\":1080,\"resize\":\"fit\"},\"thumb\":{\"w\":150,\"h\":150,\"resize\":\"crop\"},\"small\":{\"w\":680,\"h\":680,\"resize\":\"fit\"}},\"source_user_id\":14872237,\"source_user_id_str\":\"14872237\",\"video_info\":{\"aspect_ratio\":[1,1],\"duration_millis\":26960,\"variants\":[{\"content_type\":\"application/x-mpegURL\",\"url\":\"https://video.twimg.com/amplify_video/1787497086348296192/pl/Mi1S8Xgk6-KS2vu6.m3u8?tag=16\"},{\"bitrate\":432000,\"content_type\":\"video/mp4\",\"url\":\"https://video.twimg.com/amplify_video/1787497086348296192/vid/avc1/320x320/152VyUmJ16La8vLb.mp4?tag=16\"},{\"bitrate\":8768000,\"content_type\":\"video/mp4\",\"url\":\"https://video.twimg.com/amplify_video/1787497086348296192/vid/avc1/1080x1080/okb0Aj0iAofiLJsZ.mp4?tag=16\"},{\"bitrate\":832000,\"content_type\":\"video/mp4\",\"url\":\"https://video.twimg.com/amplify_video/1787497086348296192/vid/avc1/540x540/YLO8k6L1vJepkkb7.mp4?tag=16\"},{\"bitrate\":1280000,\"content_type\":\"video/mp4\",\"url\":\"https://video.twimg.com/amplify_video/1787497086348296192/vid/avc1/720x720/Krd9E6M8-t3_UTLB.mp4?tag=16\"}]},\"media_key\":\"13_1787497086348296192\",\"ext\":{\"mediaColor\":{\"r\":{\"ok\":{\"palette\":[{\"rgb\":{\"red\":38,\"green\":38,\"blue\":47},\"percentage\":41.94},{\"rgb\":{\"red\":241,\"green\":226,\"blue\":233},\"percentage\":38.38},{\"rgb\":{\"red\":141,\"green\":124,\"blue\":118},\"percentage\":7.11},{\"rgb\":{\"red\":241,\"green\":128,\"blue\":2},\"percentage\":1.76},{\"rgb\":{\"red\":182,\"green\":200,\"blue\":251},\"percentage\":1.68}]}},\"ttl\":-1}}}}}",
                                                "type": "STRING"
                                            }
                                        },
                                        {
                                            "key": "card_url",
                                            "value": {
                                                "scribe_key": "card_url",
                                                "string_value": "https://twitter.com",
                                                "type": "STRING"
                                            }
                                        }
                                    ],
                                    "card_platform": {
                                        "platform": {
                                            "audience": {
                                                "name": "production"
                                            },
                                            "device": {
                                                "name": "Swift",
                                                "version": "12"
                                            }
                                        }
                                    },
                                    "name": "unified_card",
                                    "url": "card://1787497672754003968",
                                    "user_refs_results": []
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1787527749797912626"
                                ],
                                "editable_until_msecs": "1715018400000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": true,
                            "views": {
                                "count": "178971",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://twitter.com\" rel=\"nofollow\">Twitter for Advertisers</a>",
                            "legacy": {
                                "bookmark_count": 57,
                                "bookmarked": false,
                                "created_at": "Mon May 06 17:00:00 +0000 2024",
                                "conversation_id_str": "1787527749797912626",
                                "display_text_range": [
                                    0,
                                    118
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                96,
                                                103
                                            ],
                                            "text": "RMPlay"
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": [
                                        {
                                            "id_str": "79177048",
                                            "name": "Daktronics",
                                            "screen_name": "Daktronics",
                                            "indices": [
                                                107,
                                                118
                                            ]
                                        }
                                    ]
                                },
                                "favorite_count": 4351,
                                "favorited": false,
                                "full_text": "🏟️ ¿Cómo funciona el nuevo videomarcador 360 del Santiago Bernabéu?\n🆕 VIDEO COMPLETO (GRATIS) 👉 #RMPlay\n➡️ @Daktronics",
                                "is_quote_status": false,
                                "lang": "es",
                                "quote_count": 12,
                                "reply_count": 73,
                                "retweet_count": 411,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1787527749797912626"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1782771421715870026",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200721,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200721,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1782771421715870026"
                                ],
                                "editable_until_msecs": "1713884403000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": true,
                            "views": {
                                "count": "376719",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://studio.twitter.com\" rel=\"nofollow\">Twitter Media Studio</a>",
                            "legacy": {
                                "bookmark_count": 257,
                                "bookmarked": false,
                                "created_at": "Tue Apr 23 14:00:03 +0000 2024",
                                "conversation_id_str": "1782771421715870026",
                                "display_text_range": [
                                    0,
                                    60
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                49,
                                                59
                                            ],
                                            "text": "ElClásico"
                                        }
                                    ],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/opl9sqa5qo",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1782771421715870026/video/1",
                                            "id_str": "1782744249038991360",
                                            "indices": [
                                                61,
                                                84
                                            ],
                                            "media_key": "13_1782744249038991360",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1782744249038991360/img/jXGNPtBBSt0HheBS.jpg",
                                            "type": "video",
                                            "url": "https://t.co/oPl9Sqa5qO",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1920,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 675,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 383,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1920,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    16,
                                                    9
                                                ],
                                                "duration_millis": 46920,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1782744249038991360/pl/TWbbyNtfNS__cLCX.m3u8?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 288000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1782744249038991360/vid/avc1/480x270/Sjh9ANNglatpRqjn.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1782744249038991360/vid/avc1/640x360/pyVGaksUaLyN4w1F.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 2176000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1782744249038991360/vid/avc1/1280x720/-G-6_u42O_mzoBmX.mp4?tag=14"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1782744249038991360"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": []
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/oPl9Sqa5qO",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1782771421715870026/video/1",
                                            "id_str": "1782744249038991360",
                                            "indices": [
                                                61,
                                                84
                                            ],
                                            "media_key": "13_1782744249038991360",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1782744249038991360/img/jXGNPtBBSt0HheBS.jpg",
                                            "type": "video",
                                            "url": "https://t.co/oPl9Sqa5qO",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1920,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 675,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 383,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1920,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    16,
                                                    9
                                                ],
                                                "duration_millis": 46920,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1782744249038991360/pl/TWbbyNtfNS__cLCX.m3u8?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 288000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1782744249038991360/vid/avc1/480x270/Sjh9ANNglatpRqjn.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1782744249038991360/vid/avc1/640x360/pyVGaksUaLyN4w1F.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 2176000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1782744249038991360/vid/avc1/1280x720/-G-6_u42O_mzoBmX.mp4?tag=14"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1782744249038991360"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 12143,
                                "favorited": false,
                                "full_text": "👀 ¡La celebración en el vestuario del triunfo en #ElClásico! https://t.co/oPl9Sqa5qO",
                                "is_quote_status": false,
                                "lang": "es",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 53,
                                "reply_count": 112,
                                "retweet_count": 1183,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1782771421715870026"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1780701634844357120",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200721,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200721,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1780701634844357120"
                                ],
                                "editable_until_msecs": "1713390928000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": true,
                            "views": {
                                "count": "372318",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://twitter.com\" rel=\"nofollow\">TweetDeck Web App</a>",
                            "legacy": {
                                "bookmark_count": 17,
                                "bookmarked": false,
                                "created_at": "Wed Apr 17 20:55:28 +0000 2024",
                                "conversation_id_str": "1780701634844357120",
                                "display_text_range": [
                                    0,
                                    130
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                126,
                                                130
                                            ],
                                            "text": "UCL"
                                        }
                                    ],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/9sk9hsfrjr",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1780701634844357120/photo/1",
                                            "id_str": "1780701553420365824",
                                            "indices": [
                                                131,
                                                154
                                            ],
                                            "media_key": "3_1780701553420365824",
                                            "media_url_https": "https://pbs.twimg.com/media/GLZSoNabcAAIEb_.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/9Sk9HSFrJr",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 1,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 169,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1780701553420365824"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [
                                        {
                                            "display_url": "bit.ly/MANCITYvsRMCF",
                                            "expanded_url": "https://bit.ly/MANCITYvsRMCF",
                                            "url": "https://t.co/kJMUSP8zVw",
                                            "indices": [
                                                102,
                                                125
                                            ]
                                        }
                                    ],
                                    "user_mentions": [
                                        {
                                            "id_str": "1577698938",
                                            "name": "Manchester City",
                                            "screen_name": "ManCityES",
                                            "indices": [
                                                74,
                                                84
                                            ]
                                        },
                                        {
                                            "id_str": "14872237",
                                            "name": "Real Madrid C.F.",
                                            "screen_name": "realmadrid",
                                            "indices": [
                                                89,
                                                100
                                            ]
                                        }
                                    ]
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/9Sk9HSFrJr",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1780701634844357120/photo/1",
                                            "id_str": "1780701553420365824",
                                            "indices": [
                                                131,
                                                154
                                            ],
                                            "media_key": "3_1780701553420365824",
                                            "media_url_https": "https://pbs.twimg.com/media/GLZSoNabcAAIEb_.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/9Sk9HSFrJr",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 1,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 169,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1780701553420365824"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 4981,
                                "favorited": false,
                                "full_text": "⏸️ Final de los 90 minutos reglamentarios.\n👉 ¡Nos vamos a la prórroga!\n▶️ @ManCityES 1-1 @RealMadrid\n📱https://t.co/kJMUSP8zVw\n#UCL https://t.co/9Sk9HSFrJr",
                                "is_quote_status": false,
                                "lang": "es",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 124,
                                "reply_count": 286,
                                "retweet_count": 461,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1780701634844357120"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1780676468197974444",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200719,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200719,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1780676468197974444"
                                ],
                                "editable_until_msecs": "1713384928000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "593709",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://studio.twitter.com\" rel=\"nofollow\">Twitter Media Studio</a>",
                            "legacy": {
                                "bookmark_count": 81,
                                "bookmarked": false,
                                "created_at": "Wed Apr 17 19:15:28 +0000 2024",
                                "conversation_id_str": "1780676468197974444",
                                "display_text_range": [
                                    0,
                                    61
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                49,
                                                53
                                            ],
                                            "text": "UCL"
                                        },
                                        {
                                            "indices": [
                                                56,
                                                61
                                            ],
                                            "text": "FC24"
                                        }
                                    ],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/9w780dst7t",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1780676468197974444/video/1",
                                            "id_str": "1780676344671531008",
                                            "indices": [
                                                62,
                                                85
                                            ],
                                            "media_key": "13_1780676344671531008",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1780676344671531008/img/xMCWKVGfv5v4R4SK.jpg",
                                            "type": "video",
                                            "url": "https://t.co/9W780DsT7T",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    1,
                                                    1
                                                ],
                                                "duration_millis": 7500,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1780676344671531008/pl/c0MWCjle3tvyUa9e.m3u8?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 432000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1780676344671531008/vid/avc1/320x320/iSGWN93-8iX9HIPt.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1780676344671531008/vid/avc1/540x540/85oxaYbBPArfHhZw.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 1280000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1780676344671531008/vid/avc1/720x720/Tpcdo-i7jT4frJ2F.mp4?tag=14"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1780676344671531008"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": [
                                        {
                                            "id_str": "815671379202887684",
                                            "name": "Rodrygo Goes",
                                            "screen_name": "RodrygoGoes",
                                            "indices": [
                                                33,
                                                45
                                            ]
                                        }
                                    ]
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/9W780DsT7T",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1780676468197974444/video/1",
                                            "id_str": "1780676344671531008",
                                            "indices": [
                                                62,
                                                85
                                            ],
                                            "media_key": "13_1780676344671531008",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1780676344671531008/img/xMCWKVGfv5v4R4SK.jpg",
                                            "type": "video",
                                            "url": "https://t.co/9W780DsT7T",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    1,
                                                    1
                                                ],
                                                "duration_millis": 7500,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1780676344671531008/pl/c0MWCjle3tvyUa9e.m3u8?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 432000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1780676344671531008/vid/avc1/320x320/iSGWN93-8iX9HIPt.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1780676344671531008/vid/avc1/540x540/85oxaYbBPArfHhZw.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 1280000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1780676344671531008/vid/avc1/720x720/Tpcdo-i7jT4frJ2F.mp4?tag=14"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1780676344671531008"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 16685,
                                "favorited": false,
                                "full_text": "⚽ 12' | 0-1 | ¡¡¡GOOOOOOOOOOL de @RodrygoGoes!!!\n#UCL | #FC24 https://t.co/9W780DsT7T",
                                "is_quote_status": false,
                                "lang": "en",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 373,
                                "reply_count": 365,
                                "retweet_count": 3398,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1780676468197974444"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1779517465309110471",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200720,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200720,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1779517465309110471"
                                ],
                                "editable_until_msecs": "1713108600000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": true,
                            "views": {
                                "count": "318493",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://studio.twitter.com\" rel=\"nofollow\">Twitter Media Studio</a>",
                            "legacy": {
                                "bookmark_count": 94,
                                "bookmarked": false,
                                "created_at": "Sun Apr 14 14:30:00 +0000 2024",
                                "conversation_id_str": "1779517465309110471",
                                "display_text_range": [
                                    0,
                                    94
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                72,
                                                94
                                            ],
                                            "text": "RCDMallorcaRealMadrid"
                                        }
                                    ],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/fwvq19cevh",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1779517465309110471/video/1",
                                            "id_str": "1779498822005133312",
                                            "indices": [
                                                95,
                                                118
                                            ],
                                            "media_key": "13_1779498822005133312",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1779498822005133312/img/LvWNsywMAXx-HbWh.jpg",
                                            "type": "video",
                                            "url": "https://t.co/FWVq19ceVH",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1920,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 675,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 383,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1920,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    16,
                                                    9
                                                ],
                                                "duration_millis": 14000,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1779498822005133312/pl/XYjzmlSaBOylpjZ0.m3u8?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 288000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1779498822005133312/vid/avc1/480x270/doDkHVdOr8hFBOZ3.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1779498822005133312/vid/avc1/640x360/mcgvxS38R3N_00ry.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 2176000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1779498822005133312/vid/avc1/1280x720/RHGMuqzGyw5Wsuw7.mp4?tag=14"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1779498822005133312"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": [
                                        {
                                            "id_str": "936350294627291138",
                                            "name": "Tchouameni Aurélien",
                                            "screen_name": "atchouameni",
                                            "indices": [
                                                36,
                                                48
                                            ]
                                        },
                                        {
                                            "id_str": "2329070186",
                                            "name": "Vini Jr.",
                                            "screen_name": "vinijr",
                                            "indices": [
                                                51,
                                                58
                                            ]
                                        },
                                        {
                                            "id_str": "997533018465161218",
                                            "name": "Eduardo Camavinga",
                                            "screen_name": "Camavinga",
                                            "indices": [
                                                61,
                                                71
                                            ]
                                        }
                                    ]
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/FWVq19ceVH",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1779517465309110471/video/1",
                                            "id_str": "1779498822005133312",
                                            "indices": [
                                                95,
                                                118
                                            ],
                                            "media_key": "13_1779498822005133312",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1779498822005133312/img/LvWNsywMAXx-HbWh.jpg",
                                            "type": "video",
                                            "url": "https://t.co/FWVq19ceVH",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1920,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 675,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 383,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1920,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    16,
                                                    9
                                                ],
                                                "duration_millis": 14000,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1779498822005133312/pl/XYjzmlSaBOylpjZ0.m3u8?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 288000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1779498822005133312/vid/avc1/480x270/doDkHVdOr8hFBOZ3.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1779498822005133312/vid/avc1/640x360/mcgvxS38R3N_00ry.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 2176000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1779498822005133312/vid/avc1/1280x720/RHGMuqzGyw5Wsuw7.mp4?tag=14"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1779498822005133312"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 8401,
                                "favorited": false,
                                "full_text": "👀 POV: Cuando tu compañero marca…\n⚽ @atchouameni\n🫡 @ViniJr\n🫡 @Camavinga\n#RCDMallorcaRealMadrid https://t.co/FWVq19ceVH",
                                "is_quote_status": false,
                                "lang": "es",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 21,
                                "reply_count": 83,
                                "retweet_count": 609,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1779517465309110471"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1771627984199332340",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200717,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200717,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1771627984199332340"
                                ],
                                "editable_until_msecs": "1711227601000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": true,
                            "views": {
                                "count": "171561",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://studio.twitter.com\" rel=\"nofollow\">Twitter Media Studio</a>",
                            "legacy": {
                                "bookmark_count": 13,
                                "bookmarked": false,
                                "created_at": "Sat Mar 23 20:00:01 +0000 2024",
                                "conversation_id_str": "1771627984199332340",
                                "display_text_range": [
                                    0,
                                    140
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                31,
                                                38
                                            ],
                                            "text": "RMPlay"
                                        },
                                        {
                                            "indices": [
                                                93,
                                                105
                                            ],
                                            "text": "Madridistas"
                                        }
                                    ],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/5fujpxubb5",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1771627984199332340/video/1",
                                            "id_str": "1771536166862385152",
                                            "indices": [
                                                141,
                                                164
                                            ],
                                            "media_key": "13_1771536166862385152",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1771536166862385152/img/L-6PPHuWkSZaW-4t.jpg",
                                            "type": "video",
                                            "url": "https://t.co/5FujpxubB5",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    1,
                                                    1
                                                ],
                                                "duration_millis": 49720,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1771536166862385152/pl/8gfG0wRmP0OCjGHO.m3u8?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 432000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1771536166862385152/vid/avc1/320x320/QV98SkG1GPNeHG30.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1771536166862385152/vid/avc1/540x540/4wnoulqrBb1zhKw7.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 1280000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1771536166862385152/vid/avc1/720x720/fZHKgbnutbzKwyK5.mp4?tag=14"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1771536166862385152"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [
                                        {
                                            "display_url": "bit.ly/UniversoRMPlay…",
                                            "expanded_url": "http://bit.ly/UniversoRMPlayUSA",
                                            "url": "https://t.co/MNhiXHMMa1",
                                            "indices": [
                                                117,
                                                140
                                            ]
                                        }
                                    ],
                                    "user_mentions": [
                                        {
                                            "id_str": "14872237",
                                            "name": "Real Madrid C.F.",
                                            "screen_name": "realmadrid",
                                            "indices": [
                                                2,
                                                13
                                            ]
                                        }
                                    ]
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/5FujpxubB5",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1771627984199332340/video/1",
                                            "id_str": "1771536166862385152",
                                            "indices": [
                                                141,
                                                164
                                            ],
                                            "media_key": "13_1771536166862385152",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1771536166862385152/img/L-6PPHuWkSZaW-4t.jpg",
                                            "type": "video",
                                            "url": "https://t.co/5FujpxubB5",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    1,
                                                    1
                                                ],
                                                "duration_millis": 49720,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1771536166862385152/pl/8gfG0wRmP0OCjGHO.m3u8?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 432000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1771536166862385152/vid/avc1/320x320/QV98SkG1GPNeHG30.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1771536166862385152/vid/avc1/540x540/4wnoulqrBb1zhKw7.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 1280000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1771536166862385152/vid/avc1/720x720/fZHKgbnutbzKwyK5.mp4?tag=14"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1771536166862385152"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 2161,
                                "favorited": false,
                                "full_text": "🤍 @RealMadrid 🤝 USA 🤍\n🆕 ¡Ya en #RMPlay - UNIVERSO REAL MADRID: USA! 🇺🇸\n📺 EXCLUSIVO: Socios y #Madridistas Premium.\n🔗 https://t.co/MNhiXHMMa1 https://t.co/5FujpxubB5",
                                "is_quote_status": false,
                                "lang": "es",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 0,
                                "reply_count": 99,
                                "retweet_count": 139,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1771627984199332340"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1767234029911158806",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200719,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200719,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1767234029911158806"
                                ],
                                "editable_until_msecs": "1710180001000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": true,
                            "views": {
                                "count": "202652",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://studio.twitter.com\" rel=\"nofollow\">Twitter Media Studio</a>",
                            "legacy": {
                                "bookmark_count": 49,
                                "bookmarked": false,
                                "created_at": "Mon Mar 11 17:00:01 +0000 2024",
                                "conversation_id_str": "1767234029911158806",
                                "display_text_range": [
                                    0,
                                    131
                                ],
                                "entities": {
                                    "hashtags": [],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/o9c9613fbi",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1767234029911158806/video/1",
                                            "id_str": "1767195949149896705",
                                            "indices": [
                                                132,
                                                155
                                            ],
                                            "media_key": "13_1767195949149896705",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1767195949149896705/img/53prTgBerYaRHOeH.jpg",
                                            "type": "video",
                                            "url": "https://t.co/O9C9613fBi",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    1,
                                                    1
                                                ],
                                                "duration_millis": 65465,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1767195949149896705/pl/lLlhvmtTuyBfmXw7.m3u8?tag=17"
                                                    },
                                                    {
                                                        "bitrate": 432000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1767195949149896705/vid/avc1/320x320/Wmt-7pDPxgdqI4jX.mp4?tag=17"
                                                    },
                                                    {
                                                        "bitrate": 678400,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1767195949149896705/vid/hevc/540x540/8Ba0tdF2xibXrm9A.mp4?tag=17"
                                                    },
                                                    {
                                                        "bitrate": 992000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1767195949149896705/vid/hevc/720x720/YK7aXImBZbXo0FmJ.mp4?tag=17"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1767195949149896705"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": [
                                        {
                                            "id_str": "3395146167",
                                            "name": "Luka Modrić",
                                            "screen_name": "lukamodric10",
                                            "indices": [
                                                43,
                                                56
                                            ]
                                        },
                                        {
                                            "id_str": "423384542",
                                            "name": "LALIGA",
                                            "screen_name": "LaLiga",
                                            "indices": [
                                                60,
                                                67
                                            ]
                                        }
                                    ]
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/O9C9613fBi",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1767234029911158806/video/1",
                                            "id_str": "1767195949149896705",
                                            "indices": [
                                                132,
                                                155
                                            ],
                                            "media_key": "13_1767195949149896705",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1767195949149896705/img/53prTgBerYaRHOeH.jpg",
                                            "type": "video",
                                            "url": "https://t.co/O9C9613fBi",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    1,
                                                    1
                                                ],
                                                "duration_millis": 65465,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1767195949149896705/pl/lLlhvmtTuyBfmXw7.m3u8?tag=17"
                                                    },
                                                    {
                                                        "bitrate": 432000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1767195949149896705/vid/avc1/320x320/Wmt-7pDPxgdqI4jX.mp4?tag=17"
                                                    },
                                                    {
                                                        "bitrate": 678400,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1767195949149896705/vid/hevc/540x540/8Ba0tdF2xibXrm9A.mp4?tag=17"
                                                    },
                                                    {
                                                        "bitrate": 992000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1767195949149896705/vid/hevc/720x720/YK7aXImBZbXo0FmJ.mp4?tag=17"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1767195949149896705"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 6482,
                                "favorited": false,
                                "full_text": "🔝3️⃣5️⃣0️⃣🔝\n👏 ¡Celebra los 350 partidos de @lukamodric10 en @LaLiga con el Real Madrid disfrutando de algunos de sus mejores goles! https://t.co/O9C9613fBi",
                                "is_quote_status": false,
                                "lang": "es",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 11,
                                "reply_count": 111,
                                "retweet_count": 493,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1767234029911158806"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1757487083642314931",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200723,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200723,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1757487083642314931"
                                ],
                                "editable_until_msecs": "1707856147000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": true,
                            "views": {
                                "count": "134868",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://studio.twitter.com\" rel=\"nofollow\">Twitter Media Studio</a>",
                            "legacy": {
                                "bookmark_count": 8,
                                "bookmarked": false,
                                "created_at": "Tue Feb 13 19:29:07 +0000 2024",
                                "conversation_id_str": "1757487083642314931",
                                "display_text_range": [
                                    0,
                                    104
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                65,
                                                72
                                            ],
                                            "text": "RMPlay"
                                        },
                                        {
                                            "indices": [
                                                100,
                                                104
                                            ],
                                            "text": "UCL"
                                        }
                                    ],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/n12itxo81f",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1757487083642314931/video/1",
                                            "id_str": "1757486923654840320",
                                            "indices": [
                                                105,
                                                128
                                            ],
                                            "media_key": "13_1757486923654840320",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1757486923654840320/img/wkOkbeJ-Jr43aHgu.jpg",
                                            "type": "video",
                                            "url": "https://t.co/n12Itxo81F",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    1,
                                                    1
                                                ],
                                                "duration_millis": 16280,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1757486923654840320/pl/uP1zNotGFUDjKeU5.m3u8?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 432000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1757486923654840320/vid/avc1/320x320/2eCnRYf-ZPU0B0Y9.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1757486923654840320/vid/avc1/540x540/AkQeE0gPNc_7ntcN.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 1280000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1757486923654840320/vid/avc1/720x720/C2vncWvqvB5sJcaX.mp4?tag=14"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1757486923654840320"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [
                                        {
                                            "display_url": "bit.ly/HomeRMPlay",
                                            "expanded_url": "https://bit.ly/HomeRMPlay",
                                            "url": "https://t.co/h2vYJtRASq",
                                            "indices": [
                                                76,
                                                99
                                            ]
                                        }
                                    ],
                                    "user_mentions": [
                                        {
                                            "id_str": "1301624053816533003",
                                            "name": "Andrey Lunin",
                                            "screen_name": "AndreyLunin13",
                                            "indices": [
                                                2,
                                                16
                                            ]
                                        },
                                        {
                                            "id_str": "336720832",
                                            "name": "luis llopis",
                                            "screen_name": "atezaincoach",
                                            "indices": [
                                                20,
                                                33
                                            ]
                                        }
                                    ]
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/n12Itxo81F",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1757487083642314931/video/1",
                                            "id_str": "1757486923654840320",
                                            "indices": [
                                                105,
                                                128
                                            ],
                                            "media_key": "13_1757486923654840320",
                                            "media_url_https": "https://pbs.twimg.com/amplify_video_thumb/1757486923654840320/img/wkOkbeJ-Jr43aHgu.jpg",
                                            "type": "video",
                                            "url": "https://t.co/n12Itxo81F",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    1,
                                                    1
                                                ],
                                                "duration_millis": 16280,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1757486923654840320/pl/uP1zNotGFUDjKeU5.m3u8?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 432000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1757486923654840320/vid/avc1/320x320/2eCnRYf-ZPU0B0Y9.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1757486923654840320/vid/avc1/540x540/AkQeE0gPNc_7ntcN.mp4?tag=14"
                                                    },
                                                    {
                                                        "bitrate": 1280000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1757486923654840320/vid/avc1/720x720/C2vncWvqvB5sJcaX.mp4?tag=14"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1757486923654840320"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 1832,
                                "favorited": false,
                                "full_text": "🧤 @AndreyLunin13 ✖️ @atezaincoach 🧤\n🔴 ¡La PREVIA del partido, en #RMPlay!\n👉 https://t.co/h2vYJtRASq\n#UCL https://t.co/n12Itxo81F",
                                "is_quote_status": false,
                                "lang": "es",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 1,
                                "reply_count": 59,
                                "retweet_count": 120,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1757487083642314931"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1751289021144146036",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200718,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200718,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1751289021144146036"
                                ],
                                "editable_until_msecs": "1706378414000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "count": "328128",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://mobile.twitter.com\" rel=\"nofollow\">Twitter Web App</a>",
                            "legacy": {
                                "bookmark_count": 9,
                                "bookmarked": false,
                                "created_at": "Sat Jan 27 17:00:14 +0000 2024",
                                "conversation_id_str": "1751289021144146036",
                                "display_text_range": [
                                    0,
                                    108
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                88,
                                                108
                                            ],
                                            "text": "LasPalmasRealMadrid"
                                        }
                                    ],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/am1wfrpggo",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1751289021144146036/photo/1",
                                            "id_str": "1751288934615695360",
                                            "indices": [
                                                109,
                                                132
                                            ],
                                            "media_key": "3_1751288934615695360",
                                            "media_url_https": "https://pbs.twimg.com/media/GE3UAd7XQAAgxI5.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/aM1WfrPgGo",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 237,
                                                            "y": 162,
                                                            "h": 139,
                                                            "w": 139
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 237,
                                                            "y": 162,
                                                            "h": 139,
                                                            "w": 139
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 237,
                                                            "y": 162,
                                                            "h": 139,
                                                            "w": 139
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 237,
                                                            "y": 162,
                                                            "h": 139,
                                                            "w": 139
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 675,
                                                "width": 600,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 85,
                                                        "w": 600,
                                                        "h": 336
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 600
                                                    },
                                                    {
                                                        "x": 8,
                                                        "y": 0,
                                                        "w": 592,
                                                        "h": 675
                                                    },
                                                    {
                                                        "x": 151,
                                                        "y": 0,
                                                        "w": 338,
                                                        "h": 675
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 675
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1751288934615695360"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.x.com/am1wfrpggo",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1751289021144146036/photo/1",
                                            "id_str": "1751288954115014656",
                                            "indices": [
                                                109,
                                                132
                                            ],
                                            "media_key": "3_1751288954115014656",
                                            "media_url_https": "https://pbs.twimg.com/media/GE3UBmkXQAA-A79.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/aM1WfrPgGo",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 224,
                                                            "y": 152,
                                                            "h": 154,
                                                            "w": 154
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 224,
                                                            "y": 152,
                                                            "h": 154,
                                                            "w": 154
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 224,
                                                            "y": 152,
                                                            "h": 154,
                                                            "w": 154
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 224,
                                                            "y": 152,
                                                            "h": 154,
                                                            "w": 154
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 675,
                                                "width": 600,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 85,
                                                        "w": 600,
                                                        "h": 336
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 600
                                                    },
                                                    {
                                                        "x": 8,
                                                        "y": 0,
                                                        "w": 592,
                                                        "h": 675
                                                    },
                                                    {
                                                        "x": 151,
                                                        "y": 0,
                                                        "w": 338,
                                                        "h": 675
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 675
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1751288954115014656"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.x.com/am1wfrpggo",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1751289021144146036/photo/1",
                                            "id_str": "1751288981092769792",
                                            "indices": [
                                                109,
                                                132
                                            ],
                                            "media_key": "3_1751288981092769792",
                                            "media_url_https": "https://pbs.twimg.com/media/GE3UDLEXIAAHFt7.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/aM1WfrPgGo",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 226,
                                                            "y": 172,
                                                            "h": 152,
                                                            "w": 152
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 226,
                                                            "y": 172,
                                                            "h": 152,
                                                            "w": 152
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 226,
                                                            "y": 172,
                                                            "h": 152,
                                                            "w": 152
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 226,
                                                            "y": 172,
                                                            "h": 152,
                                                            "w": 152
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 675,
                                                "width": 600,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 85,
                                                        "w": 600,
                                                        "h": 336
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 600
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 592,
                                                        "h": 675
                                                    },
                                                    {
                                                        "x": 117,
                                                        "y": 0,
                                                        "w": 338,
                                                        "h": 675
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 675
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1751288981092769792"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.x.com/am1wfrpggo",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1751289021144146036/photo/1",
                                            "id_str": "1751288999568711681",
                                            "indices": [
                                                109,
                                                132
                                            ],
                                            "media_key": "3_1751288999568711681",
                                            "media_url_https": "https://pbs.twimg.com/media/GE3UEP5XoAEEOMN.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/aM1WfrPgGo",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 228,
                                                            "y": 162,
                                                            "h": 155,
                                                            "w": 155
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 228,
                                                            "y": 162,
                                                            "h": 155,
                                                            "w": 155
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 228,
                                                            "y": 162,
                                                            "h": 155,
                                                            "w": 155
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 228,
                                                            "y": 162,
                                                            "h": 155,
                                                            "w": 155
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 675,
                                                "width": 600,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 85,
                                                        "w": 600,
                                                        "h": 336
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 600
                                                    },
                                                    {
                                                        "x": 8,
                                                        "y": 0,
                                                        "w": 592,
                                                        "h": 675
                                                    },
                                                    {
                                                        "x": 151,
                                                        "y": 0,
                                                        "w": 338,
                                                        "h": 675
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 675
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1751288999568711681"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": [
                                        {
                                            "id_str": "936350294627291138",
                                            "name": "Tchouameni Aurélien",
                                            "screen_name": "atchouameni",
                                            "indices": [
                                                30,
                                                42
                                            ]
                                        },
                                        {
                                            "id_str": "997533018465161218",
                                            "name": "Eduardo Camavinga",
                                            "screen_name": "Camavinga",
                                            "indices": [
                                                46,
                                                56
                                            ]
                                        },
                                        {
                                            "id_str": "1292895005460312066",
                                            "name": "Arda Güler",
                                            "screen_name": "10ardaguler",
                                            "indices": [
                                                58,
                                                70
                                            ]
                                        },
                                        {
                                            "id_str": "815671379202887684",
                                            "name": "Rodrygo Goes",
                                            "screen_name": "RodrygoGoes",
                                            "indices": [
                                                74,
                                                86
                                            ]
                                        }
                                    ]
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/aM1WfrPgGo",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1751289021144146036/photo/1",
                                            "id_str": "1751288934615695360",
                                            "indices": [
                                                109,
                                                132
                                            ],
                                            "media_key": "3_1751288934615695360",
                                            "media_url_https": "https://pbs.twimg.com/media/GE3UAd7XQAAgxI5.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/aM1WfrPgGo",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 237,
                                                            "y": 162,
                                                            "h": 139,
                                                            "w": 139
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 237,
                                                            "y": 162,
                                                            "h": 139,
                                                            "w": 139
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 237,
                                                            "y": 162,
                                                            "h": 139,
                                                            "w": 139
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 237,
                                                            "y": 162,
                                                            "h": 139,
                                                            "w": 139
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 675,
                                                "width": 600,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 85,
                                                        "w": 600,
                                                        "h": 336
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 600
                                                    },
                                                    {
                                                        "x": 8,
                                                        "y": 0,
                                                        "w": 592,
                                                        "h": 675
                                                    },
                                                    {
                                                        "x": 151,
                                                        "y": 0,
                                                        "w": 338,
                                                        "h": 675
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 675
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1751288934615695360"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.twitter.com/aM1WfrPgGo",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1751289021144146036/photo/1",
                                            "id_str": "1751288954115014656",
                                            "indices": [
                                                109,
                                                132
                                            ],
                                            "media_key": "3_1751288954115014656",
                                            "media_url_https": "https://pbs.twimg.com/media/GE3UBmkXQAA-A79.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/aM1WfrPgGo",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 224,
                                                            "y": 152,
                                                            "h": 154,
                                                            "w": 154
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 224,
                                                            "y": 152,
                                                            "h": 154,
                                                            "w": 154
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 224,
                                                            "y": 152,
                                                            "h": 154,
                                                            "w": 154
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 224,
                                                            "y": 152,
                                                            "h": 154,
                                                            "w": 154
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 675,
                                                "width": 600,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 85,
                                                        "w": 600,
                                                        "h": 336
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 600
                                                    },
                                                    {
                                                        "x": 8,
                                                        "y": 0,
                                                        "w": 592,
                                                        "h": 675
                                                    },
                                                    {
                                                        "x": 151,
                                                        "y": 0,
                                                        "w": 338,
                                                        "h": 675
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 675
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1751288954115014656"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.twitter.com/aM1WfrPgGo",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1751289021144146036/photo/1",
                                            "id_str": "1751288981092769792",
                                            "indices": [
                                                109,
                                                132
                                            ],
                                            "media_key": "3_1751288981092769792",
                                            "media_url_https": "https://pbs.twimg.com/media/GE3UDLEXIAAHFt7.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/aM1WfrPgGo",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 226,
                                                            "y": 172,
                                                            "h": 152,
                                                            "w": 152
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 226,
                                                            "y": 172,
                                                            "h": 152,
                                                            "w": 152
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 226,
                                                            "y": 172,
                                                            "h": 152,
                                                            "w": 152
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 226,
                                                            "y": 172,
                                                            "h": 152,
                                                            "w": 152
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 675,
                                                "width": 600,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 85,
                                                        "w": 600,
                                                        "h": 336
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 600
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 592,
                                                        "h": 675
                                                    },
                                                    {
                                                        "x": 117,
                                                        "y": 0,
                                                        "w": 338,
                                                        "h": 675
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 675
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1751288981092769792"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.twitter.com/aM1WfrPgGo",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1751289021144146036/photo/1",
                                            "id_str": "1751288999568711681",
                                            "indices": [
                                                109,
                                                132
                                            ],
                                            "media_key": "3_1751288999568711681",
                                            "media_url_https": "https://pbs.twimg.com/media/GE3UEP5XoAEEOMN.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/aM1WfrPgGo",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 228,
                                                            "y": 162,
                                                            "h": 155,
                                                            "w": 155
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 228,
                                                            "y": 162,
                                                            "h": 155,
                                                            "w": 155
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 228,
                                                            "y": 162,
                                                            "h": 155,
                                                            "w": 155
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 228,
                                                            "y": 162,
                                                            "h": 155,
                                                            "w": 155
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 675,
                                                    "w": 600,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 675,
                                                "width": 600,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 85,
                                                        "w": 600,
                                                        "h": 336
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 600
                                                    },
                                                    {
                                                        "x": 8,
                                                        "y": 0,
                                                        "w": 592,
                                                        "h": 675
                                                    },
                                                    {
                                                        "x": 151,
                                                        "y": 0,
                                                        "w": 338,
                                                        "h": 675
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 600,
                                                        "h": 675
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1751288999568711681"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 4368,
                                "favorited": false,
                                "full_text": "🔁 81' | 1-1 | Doble cambio: \n\n@atchouameni ↔️ @Camavinga \n@10ardaguler ↔️ @RodrygoGoes\n\n#LasPalmasRealMadrid https://t.co/aM1WfrPgGo",
                                "is_quote_status": false,
                                "lang": "es",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 30,
                                "reply_count": 130,
                                "retweet_count": 196,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1751289021144146036"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1658926090688118787",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200720,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200720,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1658926090688118787"
                                ],
                                "editable_until_msecs": "1684355576000",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": true,
                            "views": {
                                "count": "957683",
                                "state": "EnabledWithCount"
                            },
                            "source": "<a href=\"https://about.twitter.com/products/tweetdeck\" rel=\"nofollow\">TweetDeck</a>",
                            "legacy": {
                                "bookmark_count": 7,
                                "bookmarked": false,
                                "created_at": "Wed May 17 20:02:56 +0000 2023",
                                "conversation_id_str": "1658926090688118787",
                                "display_text_range": [
                                    0,
                                    137
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                133,
                                                137
                                            ],
                                            "text": "UCL"
                                        }
                                    ],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/ab2mciyton",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1658926090688118787/photo/1",
                                            "id_str": "1658925770427846658",
                                            "indices": [
                                                138,
                                                161
                                            ],
                                            "media_key": "3_1658925770427846658",
                                            "media_url_https": "https://pbs.twimg.com/media/FwWwMucX0AImlkK.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/ab2McIYtON",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 292,
                                                            "y": 288,
                                                            "h": 110,
                                                            "w": 110
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 259,
                                                            "y": 256,
                                                            "h": 97,
                                                            "w": 97
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 147,
                                                            "y": 145,
                                                            "h": 55,
                                                            "w": 55
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 292,
                                                            "y": 288,
                                                            "h": 110,
                                                            "w": 110
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 34,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1658925770427846658"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [
                                        {
                                            "display_url": "twitch.tv/realmadrid/",
                                            "expanded_url": "http://twitch.tv/realmadrid/",
                                            "url": "https://t.co/jf8ST3gscK",
                                            "indices": [
                                                83,
                                                106
                                            ]
                                        },
                                        {
                                            "display_url": "bit.ly/MCY_RMA",
                                            "expanded_url": "http://bit.ly/MCY_RMA",
                                            "url": "https://t.co/WikusPMX0w",
                                            "indices": [
                                                109,
                                                132
                                            ]
                                        }
                                    ],
                                    "user_mentions": [
                                        {
                                            "id_str": "1577698938",
                                            "name": "Manchester City",
                                            "screen_name": "ManCityES",
                                            "indices": [
                                                24,
                                                34
                                            ]
                                        },
                                        {
                                            "id_str": "14872237",
                                            "name": "Real Madrid C.F.",
                                            "screen_name": "realmadrid",
                                            "indices": [
                                                39,
                                                50
                                            ]
                                        },
                                        {
                                            "id_str": "1275823901629730818",
                                            "name": "Twitch ES",
                                            "screen_name": "TwitchES",
                                            "indices": [
                                                72,
                                                81
                                            ]
                                        }
                                    ]
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/ab2McIYtON",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1658926090688118787/photo/1",
                                            "id_str": "1658925770427846658",
                                            "indices": [
                                                138,
                                                161
                                            ],
                                            "media_key": "3_1658925770427846658",
                                            "media_url_https": "https://pbs.twimg.com/media/FwWwMucX0AImlkK.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/ab2McIYtON",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 292,
                                                            "y": 288,
                                                            "h": 110,
                                                            "w": 110
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 259,
                                                            "y": 256,
                                                            "h": 97,
                                                            "w": 97
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 147,
                                                            "y": 145,
                                                            "h": 55,
                                                            "w": 55
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 292,
                                                            "y": 288,
                                                            "h": 110,
                                                            "w": 110
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1350,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1200,
                                                    "w": 960,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 544,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1350,
                                                "width": 1080,
                                                "focus_rects": [
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 605
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1080
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1231
                                                    },
                                                    {
                                                        "x": 34,
                                                        "y": 0,
                                                        "w": 675,
                                                        "h": 1350
                                                    },
                                                    {
                                                        "x": 0,
                                                        "y": 0,
                                                        "w": 1080,
                                                        "h": 1350
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_1658925770427846658"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 7700,
                                "favorited": false,
                                "full_text": "🔛 ¡HASTA EL FINAL! 🔛\n▶️ @ManCityES 2-0 @RealMadrid\n🟣 𝙈𝙄𝙉𝙐𝙏𝙊 𝘼 𝙈𝙄𝙉𝙐𝙏𝙊 en @TwitchES: https://t.co/jf8ST3gscK\n💻 https://t.co/WikusPMX0w\n#UCL https://t.co/ab2McIYtON",
                                "is_quote_status": false,
                                "lang": "es",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 52,
                                "reply_count": 301,
                                "retweet_count": 401,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1658926090688118787"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "1257642297136644096",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200718,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200718,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "1257642297136644096"
                                ],
                                "editable_until_msecs": "1588682064158",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": false,
                            "views": {
                                "state": "Enabled"
                            },
                            "source": "<a href=\"https://studio.twitter.com\" rel=\"nofollow\">Twitter Media Studio</a>",
                            "legacy": {
                                "bookmark_count": 72,
                                "bookmarked": false,
                                "created_at": "Tue May 05 12:04:24 +0000 2020",
                                "conversation_id_str": "1257642297136644096",
                                "display_text_range": [
                                    0,
                                    151
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                15,
                                                22
                                            ],
                                            "text": "Zidane"
                                        },
                                        {
                                            "indices": [
                                                125,
                                                138
                                            ],
                                            "text": "RMFansEnCasa"
                                        },
                                        {
                                            "indices": [
                                                141,
                                                151
                                            ],
                                            "text": "RMHistory"
                                        }
                                    ],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/5sbss4gnql",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1257642297136644096/video/1",
                                            "id_str": "1257632055661334528",
                                            "indices": [
                                                152,
                                                175
                                            ],
                                            "media_key": "13_1257632055661334528",
                                            "media_url_https": "https://pbs.twimg.com/media/EXQK6spX0AA3xmp.jpg",
                                            "type": "video",
                                            "url": "https://t.co/5sBSs4gnQl",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 720,
                                                    "w": 720,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 720,
                                                    "w": 720,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 720,
                                                "width": 720,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    1,
                                                    1
                                                ],
                                                "duration_millis": 59560,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1257632055661334528/pl/0XHaV8-N5u_C3vrD.m3u8?tag=13"
                                                    },
                                                    {
                                                        "bitrate": 432000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1257632055661334528/vid/320x320/1VLDuCeU2PYYzh85.mp4?tag=13"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1257632055661334528/vid/480x480/jY8vU9MrStf-M45y.mp4?tag=13"
                                                    },
                                                    {
                                                        "bitrate": 1280000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1257632055661334528/vid/720x720/l5besPFcqxmgN1Ng.mp4?tag=13"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1257632055661334528"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": [
                                        {
                                            "id_str": "3003338945",
                                            "name": "Liga de Campeones",
                                            "screen_name": "LigadeCampeones",
                                            "indices": [
                                                48,
                                                64
                                            ]
                                        },
                                        {
                                            "id_str": "3525240495",
                                            "name": "Bayer 04 Leverkusen",
                                            "screen_name": "bayer04_es",
                                            "indices": [
                                                91,
                                                102
                                            ]
                                        }
                                    ]
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/5sBSs4gnQl",
                                            "expanded_url": "https://twitter.com/realmadrid/status/1257642297136644096/video/1",
                                            "id_str": "1257632055661334528",
                                            "indices": [
                                                152,
                                                175
                                            ],
                                            "media_key": "13_1257632055661334528",
                                            "media_url_https": "https://pbs.twimg.com/media/EXQK6spX0AA3xmp.jpg",
                                            "type": "video",
                                            "url": "https://t.co/5sBSs4gnQl",
                                            "additional_media_info": {
                                                "title": "",
                                                "description": "",
                                                "embeddable": true,
                                                "monetizable": true
                                            },
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 720,
                                                    "w": 720,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 720,
                                                    "w": 720,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 720,
                                                "width": 720,
                                                "focus_rects": []
                                            },
                                            "video_info": {
                                                "aspect_ratio": [
                                                    1,
                                                    1
                                                ],
                                                "duration_millis": 59560,
                                                "variants": [
                                                    {
                                                        "content_type": "application/x-mpegURL",
                                                        "url": "https://video.twimg.com/amplify_video/1257632055661334528/pl/0XHaV8-N5u_C3vrD.m3u8?tag=13"
                                                    },
                                                    {
                                                        "bitrate": 432000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1257632055661334528/vid/320x320/1VLDuCeU2PYYzh85.mp4?tag=13"
                                                    },
                                                    {
                                                        "bitrate": 832000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1257632055661334528/vid/480x480/jY8vU9MrStf-M45y.mp4?tag=13"
                                                    },
                                                    {
                                                        "bitrate": 1280000,
                                                        "content_type": "video/mp4",
                                                        "url": "https://video.twimg.com/amplify_video/1257632055661334528/vid/720x720/l5besPFcqxmgN1Ng.mp4?tag=13"
                                                    }
                                                ]
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "13_1257632055661334528"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 14323,
                                "favorited": false,
                                "full_text": "😍🔝 La volea de #Zidane, ¡el gol más bello de la @LigadeCampeones para '@francefootball'!\n🆚 @bayer04_es\n🏆 Final de la Novena \n#RMFansEnCasa | #RMHistory https://t.co/5sBSs4gnQl",
                                "is_quote_status": false,
                                "lang": "es",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 329,
                                "reply_count": 151,
                                "retweet_count": 2757,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "1257642297136644096"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "893895351043751936",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200719,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200719,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "893895351043751936"
                                ],
                                "editable_until_msecs": "1501958034118",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": true,
                            "views": {
                                "state": "Enabled"
                            },
                            "source": "<a href=\"https://about.twitter.com/products/tweetdeck\" rel=\"nofollow\">TweetDeck</a>",
                            "legacy": {
                                "bookmark_count": 2,
                                "bookmarked": false,
                                "created_at": "Sat Aug 05 18:03:54 +0000 2017",
                                "conversation_id_str": "893895351043751936",
                                "display_text_range": [
                                    0,
                                    88
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                6,
                                                13
                                            ],
                                            "text": "RMCity"
                                        },
                                        {
                                            "indices": [
                                                77,
                                                88
                                            ],
                                            "text": "HalaMadrid"
                                        }
                                    ],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/uqjlvqjbtd",
                                            "expanded_url": "https://twitter.com/realmadrid/status/893895351043751936/photo/1",
                                            "id_str": "893892042723647488",
                                            "indices": [
                                                89,
                                                112
                                            ],
                                            "media_key": "3_893892042723647488",
                                            "media_url_https": "https://pbs.twimg.com/media/DGe-E6oXYAAh5ua.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/uQJlvQJbtD",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 428,
                                                            "y": 91,
                                                            "h": 92,
                                                            "w": 92
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 428,
                                                            "y": 91,
                                                            "h": 92,
                                                            "w": 92
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 269,
                                                            "y": 57,
                                                            "h": 57,
                                                            "w": 57
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 428,
                                                            "y": 91,
                                                            "h": 92,
                                                            "w": 92
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_893892042723647488"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.x.com/uqjlvqjbtd",
                                            "expanded_url": "https://twitter.com/realmadrid/status/893895351043751936/photo/1",
                                            "id_str": "893892042698444801",
                                            "indices": [
                                                89,
                                                112
                                            ],
                                            "media_key": "3_893892042698444801",
                                            "media_url_https": "https://pbs.twimg.com/media/DGe-E6iW0AEyGbf.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/uQJlvQJbtD",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 256,
                                                            "y": 238,
                                                            "h": 58,
                                                            "w": 58
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 256,
                                                            "y": 238,
                                                            "h": 58,
                                                            "w": 58
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 161,
                                                            "y": 149,
                                                            "h": 36,
                                                            "w": 36
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 256,
                                                            "y": 238,
                                                            "h": 58,
                                                            "w": 58
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_893892042698444801"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.x.com/uqjlvqjbtd",
                                            "expanded_url": "https://twitter.com/realmadrid/status/893895351043751936/photo/1",
                                            "id_str": "893892042652344320",
                                            "indices": [
                                                89,
                                                112
                                            ],
                                            "media_key": "3_893892042652344320",
                                            "media_url_https": "https://pbs.twimg.com/media/DGe-E6XXYAAQgqu.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/uQJlvQJbtD",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 190,
                                                            "y": 124,
                                                            "h": 80,
                                                            "w": 80
                                                        },
                                                        {
                                                            "x": 916,
                                                            "y": 698,
                                                            "h": 111,
                                                            "w": 111
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 190,
                                                            "y": 124,
                                                            "h": 80,
                                                            "w": 80
                                                        },
                                                        {
                                                            "x": 916,
                                                            "y": 698,
                                                            "h": 111,
                                                            "w": 111
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 119,
                                                            "y": 78,
                                                            "h": 50,
                                                            "w": 50
                                                        },
                                                        {
                                                            "x": 576,
                                                            "y": 439,
                                                            "h": 69,
                                                            "w": 69
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 190,
                                                            "y": 124,
                                                            "h": 80,
                                                            "w": 80
                                                        },
                                                        {
                                                            "x": 916,
                                                            "y": 698,
                                                            "h": 111,
                                                            "w": 111
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_893892042652344320"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.x.com/uqjlvqjbtd",
                                            "expanded_url": "https://twitter.com/realmadrid/status/893895351043751936/photo/1",
                                            "id_str": "893892042627198978",
                                            "indices": [
                                                89,
                                                112
                                            ],
                                            "media_key": "3_893892042627198978",
                                            "media_url_https": "https://pbs.twimg.com/media/DGe-E6RXsAI-rSi.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/uQJlvQJbtD",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 332,
                                                            "y": 329,
                                                            "h": 62,
                                                            "w": 62
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 332,
                                                            "y": 329,
                                                            "h": 62,
                                                            "w": 62
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 209,
                                                            "y": 207,
                                                            "h": 39,
                                                            "w": 39
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 332,
                                                            "y": 329,
                                                            "h": 62,
                                                            "w": 62
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_893892042627198978"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [],
                                    "user_mentions": [
                                        {
                                            "id_str": "155659213",
                                            "name": "Cristiano Ronaldo",
                                            "screen_name": "Cristiano",
                                            "indices": [
                                                15,
                                                25
                                            ]
                                        }
                                    ]
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/uQJlvQJbtD",
                                            "expanded_url": "https://twitter.com/realmadrid/status/893895351043751936/photo/1",
                                            "id_str": "893892042723647488",
                                            "indices": [
                                                89,
                                                112
                                            ],
                                            "media_key": "3_893892042723647488",
                                            "media_url_https": "https://pbs.twimg.com/media/DGe-E6oXYAAh5ua.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/uQJlvQJbtD",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 428,
                                                            "y": 91,
                                                            "h": 92,
                                                            "w": 92
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 428,
                                                            "y": 91,
                                                            "h": 92,
                                                            "w": 92
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 269,
                                                            "y": 57,
                                                            "h": 57,
                                                            "w": 57
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 428,
                                                            "y": 91,
                                                            "h": 92,
                                                            "w": 92
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_893892042723647488"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.twitter.com/uQJlvQJbtD",
                                            "expanded_url": "https://twitter.com/realmadrid/status/893895351043751936/photo/1",
                                            "id_str": "893892042698444801",
                                            "indices": [
                                                89,
                                                112
                                            ],
                                            "media_key": "3_893892042698444801",
                                            "media_url_https": "https://pbs.twimg.com/media/DGe-E6iW0AEyGbf.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/uQJlvQJbtD",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 256,
                                                            "y": 238,
                                                            "h": 58,
                                                            "w": 58
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 256,
                                                            "y": 238,
                                                            "h": 58,
                                                            "w": 58
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 161,
                                                            "y": 149,
                                                            "h": 36,
                                                            "w": 36
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 256,
                                                            "y": 238,
                                                            "h": 58,
                                                            "w": 58
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_893892042698444801"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.twitter.com/uQJlvQJbtD",
                                            "expanded_url": "https://twitter.com/realmadrid/status/893895351043751936/photo/1",
                                            "id_str": "893892042652344320",
                                            "indices": [
                                                89,
                                                112
                                            ],
                                            "media_key": "3_893892042652344320",
                                            "media_url_https": "https://pbs.twimg.com/media/DGe-E6XXYAAQgqu.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/uQJlvQJbtD",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 190,
                                                            "y": 124,
                                                            "h": 80,
                                                            "w": 80
                                                        },
                                                        {
                                                            "x": 916,
                                                            "y": 698,
                                                            "h": 111,
                                                            "w": 111
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 190,
                                                            "y": 124,
                                                            "h": 80,
                                                            "w": 80
                                                        },
                                                        {
                                                            "x": 916,
                                                            "y": 698,
                                                            "h": 111,
                                                            "w": 111
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 119,
                                                            "y": 78,
                                                            "h": 50,
                                                            "w": 50
                                                        },
                                                        {
                                                            "x": 576,
                                                            "y": 439,
                                                            "h": 69,
                                                            "w": 69
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 190,
                                                            "y": 124,
                                                            "h": 80,
                                                            "w": 80
                                                        },
                                                        {
                                                            "x": 916,
                                                            "y": 698,
                                                            "h": 111,
                                                            "w": 111
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_893892042652344320"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.twitter.com/uQJlvQJbtD",
                                            "expanded_url": "https://twitter.com/realmadrid/status/893895351043751936/photo/1",
                                            "id_str": "893892042627198978",
                                            "indices": [
                                                89,
                                                112
                                            ],
                                            "media_key": "3_893892042627198978",
                                            "media_url_https": "https://pbs.twimg.com/media/DGe-E6RXsAI-rSi.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/uQJlvQJbtD",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 332,
                                                            "y": 329,
                                                            "h": 62,
                                                            "w": 62
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 332,
                                                            "y": 329,
                                                            "h": 62,
                                                            "w": 62
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 209,
                                                            "y": 207,
                                                            "h": 39,
                                                            "w": 39
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 332,
                                                            "y": 329,
                                                            "h": 62,
                                                            "w": 62
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1080,
                                                    "w": 1080,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 680,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1080,
                                                "width": 1080,
                                                "focus_rects": []
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_893892042627198978"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 12803,
                                "favorited": false,
                                "full_text": "☝️⚽️💪 #RMCity\n¡@Cristiano Ronaldo vuelve a los entrenamientos con el grupo!\n\n#HalaMadrid https://t.co/uQJlvQJbtD",
                                "is_quote_status": false,
                                "lang": "es",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 272,
                                "reply_count": 246,
                                "retweet_count": 3196,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "893895351043751936"
                            }
                        }
                    }
                }
            },
            {
                "data": {
                    "tweetResult": {
                        "result": {
                            "__typename": "Tweet",
                            "rest_id": "821376637602328576",
                            "core": {
                                "user_results": {
                                    "result": {
                                        "__typename": "User",
                                        "id": "VXNlcjoxNDg3MjIzNw==",
                                        "rest_id": "14872237",
                                        "affiliates_highlighted_label": {},
                                        "is_blue_verified": true,
                                        "profile_image_shape": "Square",
                                        "legacy": {
                                            "created_at": "Thu May 22 19:25:51 +0000 2008",
                                            "default_profile": false,
                                            "default_profile_image": false,
                                            "description": "⚽️ Cuenta oficial del Real Madrid C.F. 🏆@realmadriden: 🇬🇧🇺🇸 @realmadridarab: العربية @realmadridfra: 🇫🇷 @realmadridjapan: 🇯🇵 @realmadridpt: 🇧🇷🇵🇹",
                                            "entities": {
                                                "description": {
                                                    "urls": []
                                                },
                                                "url": {
                                                    "urls": [
                                                        {
                                                            "display_url": "bit.ly/RealMadridRMPl…",
                                                            "expanded_url": "https://bit.ly/RealMadridRMPlay",
                                                            "url": "https://t.co/iXjSgoOMZ8",
                                                            "indices": [
                                                                0,
                                                                23
                                                            ]
                                                        }
                                                    ]
                                                }
                                            },
                                            "fast_followers_count": 0,
                                            "favourites_count": 956,
                                            "followers_count": 51200723,
                                            "friends_count": 64,
                                            "has_custom_timelines": true,
                                            "is_translator": false,
                                            "listed_count": 44853,
                                            "location": "Madrid, Spain",
                                            "media_count": 47354,
                                            "name": "Real Madrid C.F.",
                                            "normal_followers_count": 51200723,
                                            "pinned_tweet_ids_str": [],
                                            "possibly_sensitive": false,
                                            "profile_banner_url": "https://pbs.twimg.com/profile_banners/14872237/1717280781",
                                            "profile_image_url_https": "https://pbs.twimg.com/profile_images/1638090920951250944/QEPY4cpL_normal.jpg",
                                            "profile_interstitial_type": "",
                                            "screen_name": "realmadrid",
                                            "statuses_count": 98515,
                                            "translator_type": "regular",
                                            "url": "https://t.co/iXjSgoOMZ8",
                                            "verified": false,
                                            "verified_type": "Business",
                                            "withheld_in_countries": []
                                        }
                                    }
                                }
                            },
                            "unmention_data": {},
                            "edit_control": {
                                "edit_tweet_ids": [
                                    "821376637602328576"
                                ],
                                "editable_until_msecs": "1484668225501",
                                "is_edit_eligible": true,
                                "edits_remaining": "5"
                            },
                            "is_translatable": true,
                            "views": {
                                "state": "Enabled"
                            },
                            "source": "<a href=\"https://about.twitter.com/products/tweetdeck\" rel=\"nofollow\">TweetDeck</a>",
                            "legacy": {
                                "bookmark_count": 0,
                                "bookmarked": false,
                                "created_at": "Tue Jan 17 15:20:25 +0000 2017",
                                "conversation_id_str": "821376637602328576",
                                "display_text_range": [
                                    0,
                                    95
                                ],
                                "entities": {
                                    "hashtags": [
                                        {
                                            "indices": [
                                                46,
                                                53
                                            ],
                                            "text": "RMCity"
                                        },
                                        {
                                            "indices": [
                                                84,
                                                95
                                            ],
                                            "text": "HalaMadrid"
                                        }
                                    ],
                                    "media": [
                                        {
                                            "display_url": "pic.x.com/8ktabf2pk9",
                                            "expanded_url": "https://twitter.com/realmadrid/status/821376637602328576/photo/1",
                                            "id_str": "821376096570667010",
                                            "indices": [
                                                96,
                                                119
                                            ],
                                            "media_key": "3_821376096570667010",
                                            "media_url_https": "https://pbs.twimg.com/media/C2YdNT8XcAIuvCl.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/8kTabF2PK9",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 959,
                                                    "w": 1500,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 767,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 435,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 959,
                                                "width": 1500,
                                                "focus_rects": []
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_821376096570667010"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.x.com/8ktabf2pk9",
                                            "expanded_url": "https://twitter.com/realmadrid/status/821376637602328576/photo/1",
                                            "id_str": "821376096574853120",
                                            "indices": [
                                                96,
                                                119
                                            ],
                                            "media_key": "3_821376096574853120",
                                            "media_url_https": "https://pbs.twimg.com/media/C2YdNT9XUAAMGWM.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/8kTabF2PK9",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 84,
                                                            "y": 1152,
                                                            "h": 49,
                                                            "w": 49
                                                        },
                                                        {
                                                            "x": 41,
                                                            "y": 178,
                                                            "h": 79,
                                                            "w": 79
                                                        },
                                                        {
                                                            "x": 1029,
                                                            "y": 565,
                                                            "h": 146,
                                                            "w": 146
                                                        },
                                                        {
                                                            "x": 820,
                                                            "y": 115,
                                                            "h": 203,
                                                            "w": 203
                                                        },
                                                        {
                                                            "x": 480,
                                                            "y": 205,
                                                            "h": 218,
                                                            "w": 218
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 67,
                                                            "y": 921,
                                                            "h": 39,
                                                            "w": 39
                                                        },
                                                        {
                                                            "x": 32,
                                                            "y": 142,
                                                            "h": 63,
                                                            "w": 63
                                                        },
                                                        {
                                                            "x": 823,
                                                            "y": 452,
                                                            "h": 116,
                                                            "w": 116
                                                        },
                                                        {
                                                            "x": 656,
                                                            "y": 92,
                                                            "h": 162,
                                                            "w": 162
                                                        },
                                                        {
                                                            "x": 384,
                                                            "y": 164,
                                                            "h": 174,
                                                            "w": 174
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 38,
                                                            "y": 522,
                                                            "h": 22,
                                                            "w": 22
                                                        },
                                                        {
                                                            "x": 18,
                                                            "y": 80,
                                                            "h": 35,
                                                            "w": 35
                                                        },
                                                        {
                                                            "x": 466,
                                                            "y": 256,
                                                            "h": 66,
                                                            "w": 66
                                                        },
                                                        {
                                                            "x": 371,
                                                            "y": 52,
                                                            "h": 92,
                                                            "w": 92
                                                        },
                                                        {
                                                            "x": 217,
                                                            "y": 92,
                                                            "h": 98,
                                                            "w": 98
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 84,
                                                            "y": 1152,
                                                            "h": 49,
                                                            "w": 49
                                                        },
                                                        {
                                                            "x": 41,
                                                            "y": 178,
                                                            "h": 79,
                                                            "w": 79
                                                        },
                                                        {
                                                            "x": 1029,
                                                            "y": 565,
                                                            "h": 146,
                                                            "w": 146
                                                        },
                                                        {
                                                            "x": 820,
                                                            "y": 115,
                                                            "h": 203,
                                                            "w": 203
                                                        },
                                                        {
                                                            "x": 480,
                                                            "y": 205,
                                                            "h": 218,
                                                            "w": 218
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1457,
                                                    "w": 1500,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1166,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 661,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1457,
                                                "width": 1500,
                                                "focus_rects": []
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_821376096574853120"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.x.com/8ktabf2pk9",
                                            "expanded_url": "https://twitter.com/realmadrid/status/821376637602328576/photo/1",
                                            "id_str": "821376096566448128",
                                            "indices": [
                                                96,
                                                119
                                            ],
                                            "media_key": "3_821376096566448128",
                                            "media_url_https": "https://pbs.twimg.com/media/C2YdNT7XEAAMMAx.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/8kTabF2PK9",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 914,
                                                            "y": 71,
                                                            "h": 79,
                                                            "w": 79
                                                        },
                                                        {
                                                            "x": 1045,
                                                            "y": 123,
                                                            "h": 76,
                                                            "w": 76
                                                        },
                                                        {
                                                            "x": 314,
                                                            "y": 55,
                                                            "h": 84,
                                                            "w": 84
                                                        },
                                                        {
                                                            "x": 1183,
                                                            "y": 61,
                                                            "h": 86,
                                                            "w": 86
                                                        },
                                                        {
                                                            "x": 563,
                                                            "y": 68,
                                                            "h": 84,
                                                            "w": 84
                                                        },
                                                        {
                                                            "x": 748,
                                                            "y": 117,
                                                            "h": 83,
                                                            "w": 83
                                                        },
                                                        {
                                                            "x": 408,
                                                            "y": 139,
                                                            "h": 83,
                                                            "w": 83
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 731,
                                                            "y": 56,
                                                            "h": 63,
                                                            "w": 63
                                                        },
                                                        {
                                                            "x": 836,
                                                            "y": 98,
                                                            "h": 60,
                                                            "w": 60
                                                        },
                                                        {
                                                            "x": 251,
                                                            "y": 44,
                                                            "h": 67,
                                                            "w": 67
                                                        },
                                                        {
                                                            "x": 946,
                                                            "y": 48,
                                                            "h": 68,
                                                            "w": 68
                                                        },
                                                        {
                                                            "x": 450,
                                                            "y": 54,
                                                            "h": 67,
                                                            "w": 67
                                                        },
                                                        {
                                                            "x": 598,
                                                            "y": 93,
                                                            "h": 66,
                                                            "w": 66
                                                        },
                                                        {
                                                            "x": 326,
                                                            "y": 111,
                                                            "h": 66,
                                                            "w": 66
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 414,
                                                            "y": 32,
                                                            "h": 35,
                                                            "w": 35
                                                        },
                                                        {
                                                            "x": 473,
                                                            "y": 55,
                                                            "h": 34,
                                                            "w": 34
                                                        },
                                                        {
                                                            "x": 142,
                                                            "y": 24,
                                                            "h": 38,
                                                            "w": 38
                                                        },
                                                        {
                                                            "x": 536,
                                                            "y": 27,
                                                            "h": 38,
                                                            "w": 38
                                                        },
                                                        {
                                                            "x": 255,
                                                            "y": 30,
                                                            "h": 38,
                                                            "w": 38
                                                        },
                                                        {
                                                            "x": 339,
                                                            "y": 53,
                                                            "h": 37,
                                                            "w": 37
                                                        },
                                                        {
                                                            "x": 184,
                                                            "y": 63,
                                                            "h": 37,
                                                            "w": 37
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 914,
                                                            "y": 71,
                                                            "h": 79,
                                                            "w": 79
                                                        },
                                                        {
                                                            "x": 1045,
                                                            "y": 123,
                                                            "h": 76,
                                                            "w": 76
                                                        },
                                                        {
                                                            "x": 314,
                                                            "y": 55,
                                                            "h": 84,
                                                            "w": 84
                                                        },
                                                        {
                                                            "x": 1183,
                                                            "y": 61,
                                                            "h": 86,
                                                            "w": 86
                                                        },
                                                        {
                                                            "x": 563,
                                                            "y": 68,
                                                            "h": 84,
                                                            "w": 84
                                                        },
                                                        {
                                                            "x": 748,
                                                            "y": 117,
                                                            "h": 83,
                                                            "w": 83
                                                        },
                                                        {
                                                            "x": 408,
                                                            "y": 139,
                                                            "h": 83,
                                                            "w": 83
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 658,
                                                    "w": 1500,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 526,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 298,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 658,
                                                "width": 1500,
                                                "focus_rects": []
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_821376096566448128"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.x.com/8ktabf2pk9",
                                            "expanded_url": "https://twitter.com/realmadrid/status/821376637602328576/photo/1",
                                            "id_str": "821376096566476800",
                                            "indices": [
                                                96,
                                                119
                                            ],
                                            "media_key": "3_821376096566476800",
                                            "media_url_https": "https://pbs.twimg.com/media/C2YdNT7XgAAvm_1.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/8kTabF2PK9",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 657,
                                                            "y": 86,
                                                            "h": 67,
                                                            "w": 67
                                                        },
                                                        {
                                                            "x": 1246,
                                                            "y": 109,
                                                            "h": 84,
                                                            "w": 84
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 525,
                                                            "y": 68,
                                                            "h": 53,
                                                            "w": 53
                                                        },
                                                        {
                                                            "x": 996,
                                                            "y": 87,
                                                            "h": 67,
                                                            "w": 67
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 297,
                                                            "y": 38,
                                                            "h": 30,
                                                            "w": 30
                                                        },
                                                        {
                                                            "x": 564,
                                                            "y": 49,
                                                            "h": 38,
                                                            "w": 38
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 657,
                                                            "y": 86,
                                                            "h": 67,
                                                            "w": 67
                                                        },
                                                        {
                                                            "x": 1246,
                                                            "y": 109,
                                                            "h": 84,
                                                            "w": 84
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 706,
                                                    "w": 1500,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 565,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 320,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 706,
                                                "width": 1500,
                                                "focus_rects": []
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_821376096566476800"
                                                }
                                            }
                                        }
                                    ],
                                    "symbols": [],
                                    "timestamps": [],
                                    "urls": [
                                        {
                                            "display_url": "bit.ly/Bisbal_RMCity",
                                            "expanded_url": "http://bit.ly/Bisbal_RMCity",
                                            "url": "https://t.co/vGChdKrIl7",
                                            "indices": [
                                                59,
                                                82
                                            ]
                                        }
                                    ],
                                    "user_mentions": [
                                        {
                                            "id_str": "57099808",
                                            "name": "davidbisbal",
                                            "screen_name": "davidbisbal",
                                            "indices": [
                                                5,
                                                17
                                            ]
                                        }
                                    ]
                                },
                                "extended_entities": {
                                    "media": [
                                        {
                                            "display_url": "pic.twitter.com/8kTabF2PK9",
                                            "expanded_url": "https://twitter.com/realmadrid/status/821376637602328576/photo/1",
                                            "id_str": "821376096570667010",
                                            "indices": [
                                                96,
                                                119
                                            ],
                                            "media_key": "3_821376096570667010",
                                            "media_url_https": "https://pbs.twimg.com/media/C2YdNT8XcAIuvCl.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/8kTabF2PK9",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": []
                                                },
                                                "medium": {
                                                    "faces": []
                                                },
                                                "small": {
                                                    "faces": []
                                                },
                                                "orig": {
                                                    "faces": []
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 959,
                                                    "w": 1500,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 767,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 435,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 959,
                                                "width": 1500,
                                                "focus_rects": []
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_821376096570667010"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.twitter.com/8kTabF2PK9",
                                            "expanded_url": "https://twitter.com/realmadrid/status/821376637602328576/photo/1",
                                            "id_str": "821376096574853120",
                                            "indices": [
                                                96,
                                                119
                                            ],
                                            "media_key": "3_821376096574853120",
                                            "media_url_https": "https://pbs.twimg.com/media/C2YdNT9XUAAMGWM.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/8kTabF2PK9",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 84,
                                                            "y": 1152,
                                                            "h": 49,
                                                            "w": 49
                                                        },
                                                        {
                                                            "x": 41,
                                                            "y": 178,
                                                            "h": 79,
                                                            "w": 79
                                                        },
                                                        {
                                                            "x": 1029,
                                                            "y": 565,
                                                            "h": 146,
                                                            "w": 146
                                                        },
                                                        {
                                                            "x": 820,
                                                            "y": 115,
                                                            "h": 203,
                                                            "w": 203
                                                        },
                                                        {
                                                            "x": 480,
                                                            "y": 205,
                                                            "h": 218,
                                                            "w": 218
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 67,
                                                            "y": 921,
                                                            "h": 39,
                                                            "w": 39
                                                        },
                                                        {
                                                            "x": 32,
                                                            "y": 142,
                                                            "h": 63,
                                                            "w": 63
                                                        },
                                                        {
                                                            "x": 823,
                                                            "y": 452,
                                                            "h": 116,
                                                            "w": 116
                                                        },
                                                        {
                                                            "x": 656,
                                                            "y": 92,
                                                            "h": 162,
                                                            "w": 162
                                                        },
                                                        {
                                                            "x": 384,
                                                            "y": 164,
                                                            "h": 174,
                                                            "w": 174
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 38,
                                                            "y": 522,
                                                            "h": 22,
                                                            "w": 22
                                                        },
                                                        {
                                                            "x": 18,
                                                            "y": 80,
                                                            "h": 35,
                                                            "w": 35
                                                        },
                                                        {
                                                            "x": 466,
                                                            "y": 256,
                                                            "h": 66,
                                                            "w": 66
                                                        },
                                                        {
                                                            "x": 371,
                                                            "y": 52,
                                                            "h": 92,
                                                            "w": 92
                                                        },
                                                        {
                                                            "x": 217,
                                                            "y": 92,
                                                            "h": 98,
                                                            "w": 98
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 84,
                                                            "y": 1152,
                                                            "h": 49,
                                                            "w": 49
                                                        },
                                                        {
                                                            "x": 41,
                                                            "y": 178,
                                                            "h": 79,
                                                            "w": 79
                                                        },
                                                        {
                                                            "x": 1029,
                                                            "y": 565,
                                                            "h": 146,
                                                            "w": 146
                                                        },
                                                        {
                                                            "x": 820,
                                                            "y": 115,
                                                            "h": 203,
                                                            "w": 203
                                                        },
                                                        {
                                                            "x": 480,
                                                            "y": 205,
                                                            "h": 218,
                                                            "w": 218
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 1457,
                                                    "w": 1500,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 1166,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 661,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 1457,
                                                "width": 1500,
                                                "focus_rects": []
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_821376096574853120"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.twitter.com/8kTabF2PK9",
                                            "expanded_url": "https://twitter.com/realmadrid/status/821376637602328576/photo/1",
                                            "id_str": "821376096566448128",
                                            "indices": [
                                                96,
                                                119
                                            ],
                                            "media_key": "3_821376096566448128",
                                            "media_url_https": "https://pbs.twimg.com/media/C2YdNT7XEAAMMAx.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/8kTabF2PK9",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 914,
                                                            "y": 71,
                                                            "h": 79,
                                                            "w": 79
                                                        },
                                                        {
                                                            "x": 1045,
                                                            "y": 123,
                                                            "h": 76,
                                                            "w": 76
                                                        },
                                                        {
                                                            "x": 314,
                                                            "y": 55,
                                                            "h": 84,
                                                            "w": 84
                                                        },
                                                        {
                                                            "x": 1183,
                                                            "y": 61,
                                                            "h": 86,
                                                            "w": 86
                                                        },
                                                        {
                                                            "x": 563,
                                                            "y": 68,
                                                            "h": 84,
                                                            "w": 84
                                                        },
                                                        {
                                                            "x": 748,
                                                            "y": 117,
                                                            "h": 83,
                                                            "w": 83
                                                        },
                                                        {
                                                            "x": 408,
                                                            "y": 139,
                                                            "h": 83,
                                                            "w": 83
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 731,
                                                            "y": 56,
                                                            "h": 63,
                                                            "w": 63
                                                        },
                                                        {
                                                            "x": 836,
                                                            "y": 98,
                                                            "h": 60,
                                                            "w": 60
                                                        },
                                                        {
                                                            "x": 251,
                                                            "y": 44,
                                                            "h": 67,
                                                            "w": 67
                                                        },
                                                        {
                                                            "x": 946,
                                                            "y": 48,
                                                            "h": 68,
                                                            "w": 68
                                                        },
                                                        {
                                                            "x": 450,
                                                            "y": 54,
                                                            "h": 67,
                                                            "w": 67
                                                        },
                                                        {
                                                            "x": 598,
                                                            "y": 93,
                                                            "h": 66,
                                                            "w": 66
                                                        },
                                                        {
                                                            "x": 326,
                                                            "y": 111,
                                                            "h": 66,
                                                            "w": 66
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 414,
                                                            "y": 32,
                                                            "h": 35,
                                                            "w": 35
                                                        },
                                                        {
                                                            "x": 473,
                                                            "y": 55,
                                                            "h": 34,
                                                            "w": 34
                                                        },
                                                        {
                                                            "x": 142,
                                                            "y": 24,
                                                            "h": 38,
                                                            "w": 38
                                                        },
                                                        {
                                                            "x": 536,
                                                            "y": 27,
                                                            "h": 38,
                                                            "w": 38
                                                        },
                                                        {
                                                            "x": 255,
                                                            "y": 30,
                                                            "h": 38,
                                                            "w": 38
                                                        },
                                                        {
                                                            "x": 339,
                                                            "y": 53,
                                                            "h": 37,
                                                            "w": 37
                                                        },
                                                        {
                                                            "x": 184,
                                                            "y": 63,
                                                            "h": 37,
                                                            "w": 37
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 914,
                                                            "y": 71,
                                                            "h": 79,
                                                            "w": 79
                                                        },
                                                        {
                                                            "x": 1045,
                                                            "y": 123,
                                                            "h": 76,
                                                            "w": 76
                                                        },
                                                        {
                                                            "x": 314,
                                                            "y": 55,
                                                            "h": 84,
                                                            "w": 84
                                                        },
                                                        {
                                                            "x": 1183,
                                                            "y": 61,
                                                            "h": 86,
                                                            "w": 86
                                                        },
                                                        {
                                                            "x": 563,
                                                            "y": 68,
                                                            "h": 84,
                                                            "w": 84
                                                        },
                                                        {
                                                            "x": 748,
                                                            "y": 117,
                                                            "h": 83,
                                                            "w": 83
                                                        },
                                                        {
                                                            "x": 408,
                                                            "y": 139,
                                                            "h": 83,
                                                            "w": 83
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 658,
                                                    "w": 1500,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 526,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 298,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 658,
                                                "width": 1500,
                                                "focus_rects": []
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_821376096566448128"
                                                }
                                            }
                                        },
                                        {
                                            "display_url": "pic.twitter.com/8kTabF2PK9",
                                            "expanded_url": "https://twitter.com/realmadrid/status/821376637602328576/photo/1",
                                            "id_str": "821376096566476800",
                                            "indices": [
                                                96,
                                                119
                                            ],
                                            "media_key": "3_821376096566476800",
                                            "media_url_https": "https://pbs.twimg.com/media/C2YdNT7XgAAvm_1.jpg",
                                            "type": "photo",
                                            "url": "https://t.co/8kTabF2PK9",
                                            "ext_media_availability": {
                                                "status": "Available"
                                            },
                                            "features": {
                                                "large": {
                                                    "faces": [
                                                        {
                                                            "x": 657,
                                                            "y": 86,
                                                            "h": 67,
                                                            "w": 67
                                                        },
                                                        {
                                                            "x": 1246,
                                                            "y": 109,
                                                            "h": 84,
                                                            "w": 84
                                                        }
                                                    ]
                                                },
                                                "medium": {
                                                    "faces": [
                                                        {
                                                            "x": 525,
                                                            "y": 68,
                                                            "h": 53,
                                                            "w": 53
                                                        },
                                                        {
                                                            "x": 996,
                                                            "y": 87,
                                                            "h": 67,
                                                            "w": 67
                                                        }
                                                    ]
                                                },
                                                "small": {
                                                    "faces": [
                                                        {
                                                            "x": 297,
                                                            "y": 38,
                                                            "h": 30,
                                                            "w": 30
                                                        },
                                                        {
                                                            "x": 564,
                                                            "y": 49,
                                                            "h": 38,
                                                            "w": 38
                                                        }
                                                    ]
                                                },
                                                "orig": {
                                                    "faces": [
                                                        {
                                                            "x": 657,
                                                            "y": 86,
                                                            "h": 67,
                                                            "w": 67
                                                        },
                                                        {
                                                            "x": 1246,
                                                            "y": 109,
                                                            "h": 84,
                                                            "w": 84
                                                        }
                                                    ]
                                                }
                                            },
                                            "sizes": {
                                                "large": {
                                                    "h": 706,
                                                    "w": 1500,
                                                    "resize": "fit"
                                                },
                                                "medium": {
                                                    "h": 565,
                                                    "w": 1200,
                                                    "resize": "fit"
                                                },
                                                "small": {
                                                    "h": 320,
                                                    "w": 680,
                                                    "resize": "fit"
                                                },
                                                "thumb": {
                                                    "h": 150,
                                                    "w": 150,
                                                    "resize": "crop"
                                                }
                                            },
                                            "original_info": {
                                                "height": 706,
                                                "width": 1500,
                                                "focus_rects": []
                                            },
                                            "media_results": {
                                                "result": {
                                                    "media_key": "3_821376096566476800"
                                                }
                                            }
                                        }
                                    ]
                                },
                                "favorite_count": 2214,
                                "favorited": false,
                                "full_text": "🎤🎸🇪🇸\n@davidbisbal estuvo con los jugadores en #RMCity. \n\n👉 https://t.co/vGChdKrIl7\n\n#HalaMadrid https://t.co/8kTabF2PK9",
                                "is_quote_status": false,
                                "lang": "es",
                                "possibly_sensitive": false,
                                "possibly_sensitive_editable": true,
                                "quote_count": 26,
                                "reply_count": 29,
                                "retweet_count": 693,
                                "retweeted": false,
                                "user_id_str": "14872237",
                                "id_str": "821376637602328576"
                            }
                        }
                    }
                }
            }
        ]
    }
}